import { k, b, G, a, l, F, y, fa, da as da$1, ha as ha$1, n as n$1, w, p, q as q$1, o, x, E as E$1, e, h, f as f$1, ea, $, aa as aa$1, ca, j, R, O, r, M, Z as Z$1, s, u as u$1, i, A, K, z } from './chunk-SVC64ZQW.js';
import { c } from './chunk-J2JGPZHY.js';
import { n, a as a$1, u, s as s$1, D, B, o as o$1, t, b as b$1, g, p as p$1 } from './chunk-6O5I75HI.js';
import { f as f$2, e as e$1 } from './chunk-EU5NKIY3.js';
import { f, j as j$1, e as e$2, h as h$1, d, g as g$1 } from './chunk-UTFXT4BW.js';
import Me, { css, keyframes, createGlobalStyle, useTheme, ThemeProvider } from 'styled-components';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { rgba, parseToRgb } from 'polished';
import * as Z from 'react';
import Z__default, { forwardRef, memo, useMemo, useRef, useState, useCallback, useImperativeHandle, useEffect, createElement, useLayoutEffect } from 'react';
import { animated, useSpring, useTransition } from 'react-spring';
import { defineMessages, useLocales, commonMessages, LocaleRoot, gflMessages } from '@sevenrooms/locales';
import he from 'lodash';
import { Breadcrumbs } from '@sevenrooms/react-components/components/Breadcrumbs';
import { useThrottledCallback } from 'use-debounce';
import mo from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Carousel, useCarousel } from 'nuka-carousel';
import { ExperienceBySevenRooms } from '@sevenrooms/react-components/components/ExperienceBySevenRooms';
import { Link, useNavigation, useSurfaceScope, useLocation, matchPath } from '@sevenrooms/navigation';
import zl from 'react-focus-lock';
import Yn from 'react-merge-refs';
import { TouchScrollable } from 'react-scrolllock';
import { ToastContainer, cssTransition, toast, Slide, Bounce, Zoom, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $d from 'css-time';
import Wd from 'react-keyboard-event-handler';
import { Transition } from 'react-transition-group';
import { useCombobox } from 'downshift';
import pc from 'use-resize-observer';
import { useFormState } from '@sevenrooms/form';
import Mo from 'moment/moment';
import { DayPickerSingleDateController } from 'react-dates';
import 'react-dates/initialize';
import '@fontsource/roboto';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Normalize } from 'styled-normalize';
import { ThemeProvider as ThemeProvider$1, vmsTheme, gxTheme } from '@sevenrooms/react-components/components/ThemeProvider';
import * as Hi from 'react-dom';
import Kp from 'constate';
import { useTable, useSortBy, useExpanded, usePagination, useRowSelect } from 'react-table';
import * as fe from 'react-tabs';
import { parsePhoneNumber } from 'react-phone-number-input';
import { readIFrameMessage } from '@sevenrooms/connect-iframe';
import { SevenRoomsIcon } from '@sevenrooms/react-components/components/SevenRoomsIcon';
import { SevenRoomsProgress } from '@sevenrooms/react-components/components/SevenRoomsProgress';
import { Avatar } from '@sevenrooms/react-components/components/Avatar';
import { IconButton } from '@sevenrooms/react-components/components/IconButton';
import { Menu } from '@sevenrooms/react-components/components/Menu';
import { MenuItem } from '@sevenrooms/react-components/components/MenuItem';

function zr({firstName:e,lastName:t,size:o,fontSize:r,image:n,textStyle:i}){let a=e?.charAt(0)??"",s=t?.charAt(0)??"",p=a+s,d=o||"24px";return jsx(za,{width:d,height:d,image:n,fontSize:r,textStyle:i,children:n?null:p})}var za=Me(k)`
  align-items: center;
  background-color: ${e=>e.theme.colors.mutedBackground};
  border-radius: 50%;
  color: ${e=>e.theme.colors.mutedFont};
  ${e=>e.textStyle&&`font: ${e.theme.textStyles[e.textStyle]};`}
  font-size: ${e=>e.fontSize?e.theme.fontSizes[e.fontSize]:e.theme.fontSizes.s};
  justify-content: center;
  text-transform: uppercase;
  ${e=>e.image&&css`
      background-size: cover;
      background-image: url(${e.image});
    `}
`;function Vr(e){let t=useTheme(),o=Z.useMemo(()=>({visible:rgba({...parseToRgb(t.colors.backdrop),alpha:.3}),invisible:rgba({...parseToRgb(t.colors.backdrop),alpha:0})}),[t.colors.backdrop]),r=useSpring({backgroundColor:e.isActive?o.visible:o.invisible,pointerEvents:e.isActive?"all":"none",config:{duration:150}});return jsx(Ua,{...e,style:r,"data-test":"ui-kit-backdrop",children:e.children})}var Ua=Me(animated.div).withConfig({shouldForwardProp:e=>e!=="isActive"})`
  will-change: background-color, pointer-events;
  position: fixed;
  z-index: ${e=>e.theme.zIndex.modal};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;function Ru({title:e$2,description:t,to:o,isExternal:r,icon:n,...i}){let a$1=jsxs(Ka,{borderRadius:"s",borderColor:"dividerLines",borderWidth:"s",backgroundColor:"primaryBackground",alignItems:"center",justifyContent:"center",flexWrap:"wrap",...i,children:[n&&jsx(Ya,{pr:"m",flexDirection:"column",flex:"0 0",children:n}),jsxs(k,{pr:"m",flexDirection:"column",flex:"10 1 250px",children:[jsx(a,{children:jsx(e,{fontWeight:"bold",children:e$2})}),t&&jsx(j,{fontSize:"s",children:t})]}),o&&jsx(Za,{pl:"m",flexDirection:"column",flex:"0 0",children:jsx(e$1,{name:"VMSWeb-chevron-right",size:"lg"})})]});return o?jsx(R,{to:o,isExternal:r,"data-test":"action-link",children:a$1}):a$1}var Ka=Me(k)`
  ${e=>"p"in e?css`
          padding: ${b(e,e.p)};
        `:css`
          padding-top: ${b(e,e.pt)};
          padding-right: ${b(e,e.pr)};
          padding-bottom: ${b(e,e.pb)};
          padding-left: ${b(e,e.pl)};
        `}
`,Ya=Me(k)`
  ${e=>css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1.2em;
        height: 1.2em;
        border-radius: 50%;
        background-color: ${e.theme.colors.highlight};
        border: 1px solid ${e.theme.colors.brandColor};
        padding: 2px;
    `}
`,Za=Me(k)`
  ${e=>css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1.2em;
        height: 1.2em;
        border-radius: 50%;
        background-color: ${e.theme.colors.iconHover};
    `}
`;var Ur='data:image/svg+xml,<svg height="60" width="60" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"%0A  viewBox="0 0 3947 3947">%0A  <defs>%0A    <clipPath id="a">%0A      <circle cx="1973.5" cy="1973.5" r="1380" />%0A    </clipPath>%0A  </defs>%0A  <path stroke-dasharray="1706" stroke-width="150" d="M2590.15 1018.5H883.997" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0; 0.12; 0.32; 0.61; 0.70; 1"%0A      repeatCount="indefinite" values="5118; 5118; 3412; 3412; 1706; 1706;" />%0A  </path>%0A  <path stroke-dasharray="2232.73" stroke-width="150" d="M2279 1100 730.001 2708" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.16;0.4;0.65;0.74;1"%0A      repeatCount="indefinite" values="6698.19;6698.19;4465.46;4465.46;2232.73;2232.73;" />%0A  </path>%0A  <path stroke-dasharray="1822" stroke-width="150" d="M1961 1600v1822" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.23;0.4;0.72;0.81;1"%0A      repeatCount="indefinite" values="5466;5466;3644;3644;1822;1822;" />%0A  </path>%0A  <path stroke-dasharray="1330.8" stroke-width="150" d="m2029 2082 936 946" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.28;0.4;0.77;0.86;1"%0A      repeatCount="indefinite" values="3992.4;3992.4;2661.6;2661.6;1330.8;1330.8;" />%0A  </path>%0A  <circle cx="1973.5" cy="1973.5" r="1452.5" stroke-dasharray="9126.33" stroke-width="150"%0A    transform="rotate(-21 1973.5 1973.5)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.45;0.50;1" repeatCount="indefinite"%0A      values="0;9126.33;9126.33;18252.66;" />%0A  </circle>%0A  <circle cx="1973.5" cy="1973.5" r="1452.5" stroke-dasharray="20 9126.33" stroke-width="148" color="%23000"%0A    transform="rotate(-21.5 1973.5 1973.5)" />%0A  <circle cx="2674.5" cy="1719.5" r="705.5" stroke-dasharray="4432.79" stroke-width="150"%0A    transform="rotate(-22.28 2674.5 1719.5)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.45;0.50;1" repeatCount="indefinite"%0A      values="4432.79;8865.58;8865.58;13298.37;" />%0A  </circle>%0A</svg>';var Qa={xs:"24px",s:"32px",m:"48px"};function Xr({size:e="s"}){return jsx("img",{src:Ur,width:Qa[e],alt:"..."})}var es={top:"column",bottom:"column-reverse",left:"row",right:"row-reverse"};function Kr({icon:e$1,align:t="bottom",size:o="s",children:r,...n}){return jsxs(k,{flexDirection:es[t],alignItems:"center",...n,children:[jsx(a,{p:"s",children:e$1||jsx(Xr,{size:o})}),!he.isNil(r)&&jsx(a,{p:"s",children:jsx(e,{children:r})})]})}var Yr=defineMessages({dismiss:{id:"uikit.banner.dismiss",defaultMessage:"Dismiss"}});function Zr({type:e$1="warning",icon:t,title:o,action:r,onAction:n,canDismiss:i=true,onDismiss:a$1,description:s,isActionDisabled:p,isLoading:d,...m}){let{formatMessage:f}=useLocales(),c="attention";return jsx(ns,{type:e$1,pt:"m",pb:"m",pr:"lm",pl:"lm",alignItems:"center",justifyContent:"center",flexWrap:"wrap",...m,children:d?jsx(Kr,{}):jsxs(Fragment,{children:[t&&jsx(as,{pr:"m",flexDirection:"column",flex:"0 0",isAttention:e$1===c,children:t}),jsxs(k,{pr:"m",flexDirection:"column",flex:"10 1 250px",children:[o&&jsx(a,{pb:s?"xs":undefined,children:jsx(e,{fontWeight:"bold",children:o})}),s&&jsx(j,{children:s})]}),(n&&r||i&&a$1)&&jsxs(k,{justifyContent:e$1===c?"flex-end":"space-between",flex:"1 1 0",children:[n&&r&&jsx(is,{"data-test":"sr-banner-action-button",variant:e$1===c?"primary":"secondary",size:"s",onClick:n,disabled:p,isAttention:e$1===c,children:r}),a$1&&i&&jsx(G,{"data-test":"sr-banner-dismiss-button",variant:"tertiary",icon:"VMSWeb-close",onClick:a$1,children:f(Yr.dismiss)})]})]})})}var ns=Me(k)`
  ${e=>e.type!=="attention"&&css`
      border: 2px solid ${e.theme.colors[e.type]};
    `}
  border-radius: 4px;
  background-color: ${e=>e.type==="attention"?e.theme.colors.highlight:e.theme.colors[`${e.type}Background`]};
`,is=Me(G)`
  background-color: ${e=>e.isAttention?`${e.theme.colors.primaryButton} !important`:e.theme.colors.inputBackground};

  ${e=>e.isAttention&&css`
      padding: 0 1em !important;
    `}
`,as=Me(k)`
  ${e=>e.isAttention&&css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 2em;
        height: 2em;
        border-radius: 50%;
        background-color: white;
        color: ${e.theme.colors.primaryButton};
    `}
`;function ah({banners:e,setBanners:t}){let o=n=>t(e.filter(i=>i.key!==n)),r=n=>{n.onDismiss?.(),o(n.key);};return jsx(Fragment,{children:e.map((n,i)=>jsx(a,{pb:i+1!==e.length?"m":undefined,children:jsx(Zr,{...n,onDismiss:()=>r(n)})},n.key))})}var bh=Me(a)`
  border: 1px solid ${f.colors.dividerLines};
  border-radius: 4px;
  box-sizing: border-box;
  height: ${e=>e.height};
`;var qr=defineMessages({breadcrumbs:{id:"uikit.breadcrumbs.breadcrumbs",defaultMessage:"breadcrumbs"}});function Ih(e){let{formatMessage:t}=useLocales();return jsx(gs,{children:jsx(Breadcrumbs,{"aria-label":e.ariaLabel??t(qr.breadcrumbs),separator:e.separator?e.separator:jsx(a,{pt:"xxs",children:jsx(e$1,{name:"VMSWeb-chevron-right"})}),...e})})}var gs=Me.div`
  .MuiBreadcrumbs-li {
    appearance: auto;
  }

  .MuiBreadcrumbs-separator {
    margin-left: ${e=>e.theme.spacing.xs};
    margin-right: ${e=>e.theme.spacing.xs};
  }
`;function Qr({children:e,variant:t="primary",flexDirection:o="column",backgroundColor:r,borderColor:n,...i}){return jsx(xs,{variant:t,position:"relative",width:"100%",backgroundColor:r||t==="secondary"&&"secondaryBackground",borderColor:n||t==="primary"&&"borders",flexDirection:o,borderRadius:"s",...i,children:e})}var xs=Me(l)`
  overflow: hidden;

  ${e=>e.hoverable&&css`
      cursor: pointer;
      &:hover {
        background-color: ${t=>t.theme.colors.inputHoverBackground};
      }
      ${F} {
        background-color: transparent;
      }
    `}
`;function Jr({as:e,...t}){return jsx(Cs,{...t})}var Cs=Me(a)`
  ${e=>e.onClick&&css`
      cursor: pointer;
    `}
`;function de(e){return jsx(ws,{...e})}var ws=Me.div`
  ${e=>e.collapsed&&css`
      height: 0px;
      overflow: hidden;
    `}
`;function rn({hideLast:e=false,content:t,...o}){return jsxs(Rs,{"align-items":"center",hideLast:e,children:[jsx(jr,{...o}),t&&jsxs(Fragment,{children:[t,jsx(jr,{...o})]})]})}var jr=Me.hr`
  border: none;
  height: 1px;
  color: ${e=>e.color?e.theme.colors[e.color]:e.theme.colors.dividerLines};
  background-color: ${e=>e.color?e.theme.colors[e.color]:e.theme.colors.dividerLines};
  margin: ${e=>e.theme.spacing[e.margin??"s"]};
  ${e=>e.ml&&`margin-left: ${e.theme.spacing[e.ml]};`}
  ${e=>e.mr&&`margin-right: ${e.theme.spacing[e.mr]};`}
  ${e=>e.mt&&`margin-top: ${e.theme.spacing[e.mt]};`}
  ${e=>e.mb&&`margin-bottom: ${e.theme.spacing[e.mb]};`}
  width: 100%;
`,Rs=Me(k)`
  &:last-child {
    ${e=>e.hideLast&&"display: none;"}
  }
`;function lx({template:e,variablesFromTemplate:t,variables:o,venueName:r,height:n,scale:i}){let[a,s]=useState(()=>nn({template:e,variablesFromTemplate:t,variables:o})),p=useThrottledCallback(()=>{let d=nn({template:e,variablesFromTemplate:t,variables:o});i!=null&&(d=d.replace("<head>",`<head>
          <style>
            body {
              display: flex;
              justify-content: center;
              margin: 0;
              transform: scale(${i});
              transform-origin: 50% 0;
            }
          </style>
        `)),!o.venue_logo&&r&&(d=d.replace(/<[^>]*{{venue_logo}}[^>]*>/gi,r)),s(d);},500);return useEffect(()=>{p.callback();},[o,e,p]),jsx(Ws,{srcDoc:a,height:n,"data-test":"sr-email-preview-iframe"})}var nn=({template:e,variablesFromTemplate:t,variables:o})=>t.reduce((r,n)=>{let i=o[n];return i?r.replace(new RegExp(`{{${n}}}`,"ig"),String(i)):r},e),Ws=Me.iframe`
  flex-grow: 1;
  border: none;
  border-radius: 4px;
  height: ${e=>e.height??e.theme.imageUploader.height};
`;var an='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 72 73">%0A  <g clip-path="url(%23a)">%0A    <path fill="%231D1D1D"%0A      d="M36 0C16.1173 0 0 16.3411 0 36.5S16.1173 73 36 73s36-16.3411 36-36.5S55.8827 0 36 0Zm31.6442 30.7053c0 8.3792-6.6991 15.1713-14.9635 15.1713-8.2643 0-14.9634-6.7921-14.9634-15.1713 0-8.3791 6.6991-15.1713 14.9634-15.1713 8.2644 0 14.9635 6.7922 14.9635 15.1713ZM36 3.4754c9.0358 0 17.2129 3.7316 23.1138 9.7553-2.0035-.7595-4.1724-1.1744-6.4353-1.1744H14.0959C19.8805 6.7242 27.5657 3.4732 36 3.4732v.0022Zm-1.715 27.2299V69.477c-10.8872-.5714-20.359-6.5655-25.844-15.3663l26.0877-26.45a18.9792 18.9792 0 0 0-.2437 3.0446ZM6.7058 50.9549c-2.0996-4.3664-3.278-9.2701-3.278-14.4549 0-7.9597 2.7772-15.262 7.4035-20.966h31.1478a18.4893 18.4893 0 0 0-2.6787 2.3714L6.7058 50.9549ZM37.715 69.4792V41.5511a18.7569 18.7569 0 0 0 2.5849 2.9472l16.8685 17.1028c-5.2882 4.5886-12.0432 7.4882-19.4534 7.8781Zm21.9377-10.2744-9.957-10.0953c.9704.161 1.9654.2448 2.9806.2448 6.6164 0 12.4166-3.5434 15.6566-8.8597-.8564 7.2093-4.0047 13.7022-8.6825 18.7102h.0023Z" />%0A  </g>%0A  <defs>%0A    <clipPath id="a">%0A      <path fill="%23fff" d="M0 0h72v73H0z" />%0A    </clipPath>%0A  </defs>%0A</svg>';function Ze(e){let t=useRef(null);return useEffect(()=>{t.current&&e.fetchPriority&&(t.current.fetchPriority=e.fetchPriority);},[e.fetchPriority]),jsx(Ds,{ref:t,...e})}var Ds=Me.img`
  ${e=>e.centered&&css`
      object-fit: cover;
      object-position: center;
    `}
  ${e=>e.borderRadius&&css`
      border-radius: ${e.theme.borderRadius[e.borderRadius]};
    `}
  ${e=>e.maxWidth&&css`
      max-width: ${e.maxWidth};
    `}
  ${e=>e.objectFit&&css`
      object-fit: ${e.objectFit};
    `}
`,ln=Me(Ze)`
  max-width: ${e=>e.maxWidth??"100%"};
  max-height: ${e=>e.maxHeight??"100%"};

  ${e=>e.height!==undefined&&css`
      min-height: ${e.height};
    `}
`;function dn({imageUrl:e,fallback:t,onImageLoadFailure:o,...r}){let[n,i]=useState(!!e);return n?jsx(Ze,{src:e??"",onError:()=>{o?.(),i(false);},...r}):t}function ao({cropData:e,onError:t,src:o,width:r,height:n,...i}){let a=useRef(null),s=typeof r=="string"?parseFloat(r):r,p=typeof n=="string"?parseFloat(n):n,d=useRef(new Image(s,p));return d.current.onload=()=>{let m=a.current,f=m?.getContext("2d");if(!m||!f){t?.();return}let{x:c,y:b,width:u,height:y}=Us(e),x=c/100*d.current.naturalWidth,S=b/100*d.current.naturalHeight,w=u/100*d.current.naturalWidth,C=y/100*d.current.naturalHeight;m.width=s||w,m.height=p||C,f.drawImage(d.current,x,S,w,C,0,0,m.width,m.height);},d.current.onerror=t??null,d.current.src=o,jsx(Xs,{ref:a,role:"img",canvasHeight:n,canvasWidth:r,...i})}var Gs=e=>Object.values(e).every(t=>t>0),Us=e=>Gs(e)?{...e,width:e.x+e.width>100?100-e.x:e.width,height:e.y+e.height>100?100-e.y:e.height}:{x:0,y:0,width:100,height:100},Xs=Me.canvas`
  ${e=>css`
    width: ${e.canvasWidth};
    height: ${e.canvasHeight};
  `}
`;function mn(){switch(window.location.hostname){case "www.sevenrooms.com":case "eu.sevenrooms.com":return  true;default:return  false}}var Ys="Whoops! Something went wrong. Please wait a few moments and then try again.";function zx({error:e$1}){let t=mn();return jsxs(n$1,{height:"100vh",width:"100vw",children:[jsx(a,{width:"100%",textAlign:"center",p:"3xl 3xl m 3xl",children:jsx(Ze,{width:"120px",height:"120px",src:an,alt:"SevenRooms Logo"})}),jsxs(n$1,{width:"100%",flexGrow:1,alignItems:"center",spacing:"m",pt:"m",children:[jsx(e,{fontSize:"l",fontWeight:"bold",color:"darkFont",children:"Looks like this page is off the menu."}),jsx(e,{color:"darkFont",children:t||!e$1?.toString()?Ys:e$1?.toString()}),jsx(G,{"data-test":"sr-error-page-go-back",variant:"primary",href:"/",isExternal:true,children:jsx(e,{color:"lightFont",children:"Go Back"})})]})]})}function Zs(e,t){return jsx(l,{...e,ref:t,flexDirection:"row"})}var P=Z.forwardRef(Zs);function Qx({includeNavWidth:e=false,children:t,...o}){return jsx(Js,{alignItems:"center",height:"56px",width:"100%",pl:"lm",pt:"sm",pr:"lm",pb:"sm",spacing:"l",includeNavWidth:e,...o,children:t})}var Js=Me(P)`
  position: fixed;
  width: ${e=>e.includeNavWidth?`calc(100% - ${e.theme.sizes.sideNavWidth} - ${e.theme.sizes.tabsNavWidth})`:"100%"};
  bottom: 0;
  background-color: ${e=>e.theme.colors.primaryBackground};
  border: 1px solid ${e=>e.theme.colors.margin};
  box-sizing: border-box;
  box-shadow: ${e=>e.theme.shadows.primaryUp};
  border-radius: 8px 8px 0 0;
`;var gn=defineMessages({footerTotalItemSeparator:{id:"footer.item.total.separator",defaultMessage:"of {amount}"}});function sb({primary:e$1,secondary:t,label:o,info:r}){let{formatMessage:n}=useLocales(),i=t!==undefined;return jsxs(P,{spacing:"sm",alignItems:"center",children:[jsxs(P,{alignItems:"center",spacing:"xs",children:[jsx(e,{lineHeight:"s",fontSize:"xl",color:"primarySelected",children:i?t:e$1}),i&&jsx(e,{color:"primarySelected",children:n(gn.footerTotalItemSeparator,{amount:e$1})})]}),jsxs(P,{spacing:"s",children:[jsx(j,{fontSize:"s",children:o}),r&&jsx(O,{tooltip:{content:r},"data-test":"sr-additional-information"})]})]})}function nl(e,t){return jsx(il,{...e,display:"grid",ref:t})}var Tt=forwardRef(nl),il=Me(a)`
  grid-template-columns: ${e=>e.gridTemplateColumns};
  grid-template-rows: ${e=>e.gridTemplateRows};
  grid-template-areas: ${e=>e.gridTemplateAreas};
  grid-template: ${e=>e.gridTemplate};
  grid-auto-columns: ${e=>e.gridAutoColumns};
  grid-auto-rows: ${e=>e.gridAutoRows};
  grid-auto-flow: ${e=>e.gridAutoFlow};
  grid: ${e=>e.grid};
  grid-row-start: ${e=>e.gridRowStart};
  grid-column-start: ${e=>e.gridColumnStart};
  grid-row-end: ${e=>e.gridRowEnd};
  grid-column-end: ${e=>e.gridColumnEnd};
  grid-row: ${e=>e.gridRow};
  grid-column: ${e=>e.gridColumn};
  grid-area: ${e=>e.gridArea};
  align-items: ${e=>e.alignItems};
  justify-items: ${e=>e.justifyItems};

  ${e=>!he.isNil(e.gap)&&css`
      gap: ${b(e,e.gap)};
    `}

  ${e=>!he.isNil(e.rowGap)&&css`
      row-gap: ${b(e,e.rowGap)};
    `}


    ${e=>!he.isNil(e.columnGap)&&css`
      column-gap: ${b(e,e.columnGap)};
    `}
`;var Ie="#eee",un=Me(k)`
  background-image: linear-gradient(45deg, ${Ie} 25%, transparent 25%, transparent 75%, ${Ie} 75%, ${Ie}),
    linear-gradient(45deg, ${Ie} 25%, transparent 25%, transparent 75%, ${Ie} 75%, ${Ie});
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
`;var cl="default"in mo?mo.default:mo;function Wb({url:e,image:t,crop:o,onError:r,options:n,unit:i="px"}){let a=useMemo(()=>{if(o.rect&&t.dimension&&i==="%")return {...o.rect,unit:i};if(o.rect&&t.dimension)return {x:o.rect.x/t.dimension.scaleX,width:o.rect.width/t.dimension.scaleX,y:o.rect.y/t.dimension.scaleY,height:o.rect.height/t.dimension.scaleY,unit:i}},[o,t.dimension,i]),s=useCallback((d,m)=>{t.dimension&&i==="%"?o.setRect(m):t.dimension&&o.setRect({x:d.x*t.dimension.scaleX,width:d.width*t.dimension.scaleX,y:d.y*t.dimension.scaleY,height:d.height*t.dimension.scaleY,unit:i});},[o,t.dimension,i]),p=useMemo(()=>{let d="unset";return !t.element&&t.naturalSize&&(d=`${100*(t.naturalSize.height/t.naturalSize.width)}%`),d},[t]);return useEffect(()=>()=>t.setElement(undefined),[e]),jsx(ml,{children:e&&jsx(pl,{maxWidth:t.naturalSize&&`${t.naturalSize.width}px`||"unset",onDoubleClick:o.selectAll,children:jsx(fl,{spacePlaceholder:p,"data-test":"sr-logo-editor-crop-section",children:jsx(cl,{...n,crop:a,onChange:s,keepSelection:true,children:jsx("img",{src:e,alt:"being croped",onLoad:d=>t.setElement(d.currentTarget),onError:r})})})})})}var ml=Me(un)`
  width: 100%;
  align-items: center;
  justify-content: center;
`,pl=Me.div`
  max-width: ${e=>e.maxWidth};
`,I=11,E=5,fl=Me.div`
  margin: auto;
  display: flex;
  width: 100%;
  max-width: ${e=>e.spacePlaceholder};

  .ReactCrop {
    max-height: initial;
  }

  .ReactCrop__crop-selection {
    border: none;
  }

  .ReactCrop__drag-handle {
    margin: 0 !important;
  }
  .ReactCrop__drag-handle::after,
  .ReactCrop__drag-handle::before {
    border: none;
    outline: none;
    background-color: ${e=>e.theme.colors.primaryButton};
  }

  .ReactCrop__drag-handle::before {
    content: '';
    display: block;
    position: absolute;
    box-sizing: border-box;
  }

  .ReactCrop__drag-handle.ord-nw:after {
    width: ${I}px;
    height: ${E}px;
  }

  .ReactCrop__drag-handle.ord-nw:before {
    width: ${E}px;
    height: ${I}px;
  }

  .ReactCrop__drag-handle.ord-n:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-ne:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I}px;
  }

  .ReactCrop__drag-handle.ord-ne:before {
    width: ${E}px;
    height: ${I}px;
    margin-left: -${E}px;
  }

  .ReactCrop__drag-handle.ord-w:after {
    width: ${E}px;
    height: ${I}px;
    margin-top: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-e:after {
    width: ${E}px;
    height: ${I}px;
    margin-left: -${E}px;
    margin-top: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-sw:after {
    width: ${I}px;
    height: ${E}px;
    margin-top: -${I}px;
  }

  .ReactCrop__drag-handle.ord-sw:before {
    width: ${E}px;
    height: ${I}px;
    margin-top: -${I}px;
  }

  .ReactCrop__drag-handle.ord-s:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I/2}px;
    margin-top: -${E}px;
  }

  .ReactCrop__drag-handle.ord-se:after {
    width: ${I}px;
    height: ${E}px;
    margin-left: -${I/2}px;
    margin-top: -${E}px;
  }

  .ReactCrop__drag-handle.ord-se:before {
    width: ${E}px;
    height: ${I}px;
    margin-left: -${E}px;
    margin-top: -${I}px;
  }

  @media (pointer: coarse) {
    .ReactCrop__drag-handle {
      width: inherit;
      height: inherit;
    }
  }
`;var xn="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",Nb=(e,t,o)=>!e||!t||!o?xn:gl(e,o)??xn,gl=(e,t)=>{let o=document.createElement("canvas"),r=o.getContext("2d"),n=t.unit==="%"?t.x*e.naturalWidth/100:t.x,i=t.unit==="%"?t.y*e.naturalHeight/100:t.y,a=t.unit==="%"?t.width*e.naturalWidth/100:t.width,s=t.unit==="%"?t.height*e.naturalHeight/100:t.height;return o.width=a,o.height=s,r?.drawImage(e,n,i,a,s,0,0,a,s),o.toDataURL("image/png")};var ul=30;function zb({minHeight:e=ul,maxHeight:t,maxWidth:o,currentHeight:r},n={width:1,height:1,x:1,y:1}){let i=Z__default.useMemo(()=>n.width/n.height,[n]),a=Z__default.useCallback(m=>{let f=i*m;return f>o?f/n.width*n.height:m},[n,i,o]),[s,p]=Z__default.useMemo(()=>{let m=Math.min(n.height,r),f=m,c=i*m;return c>o&&(c=o,f=c/n.width*n.height),[c,f]},[n,r,o]),d=Z__default.useMemo(()=>({min:a(e),max:a(t),calculatedWidth:s,calculatedHeight:p}),[a,e,t,s,p]);return Z__default.useMemo(()=>({byHeight:d}),[d])}function _b(e,t,o,r="px"){let[n,i]=useState(t),a=useRef(e.element),s=useMemo(()=>n?!n.height&&!n.width:true,[n]),p=useCallback(()=>{if(e.naturalSize){let{width:d,height:m}=e.naturalSize,f={x:0,y:0,unit:n?.unit??r};if(!o){i({...f,width:f.unit==="%"?100:d,height:f.unit==="%"?100:m});return}let c=d/m;f.unit==="%"?i({...f,width:c<o?100:100*o/c,height:c<o?100*c/o:100}):i({...f,width:c<o?d:m*o,height:c<o?d/o:m});}},[e.naturalSize,n?.unit,r,o]);return useEffect(()=>{a.current&&a.current!==e.element&&i(undefined),a.current=e.element;},[e.element]),useEffect(()=>{s&&p();},[s,p]),{rect:n,setRect:i,selectAll:p}}function Ub(e){let[t,o]=useState(undefined),[r,n]=useState(e),i=useMemo(()=>t?{width:t.naturalWidth,height:t.naturalHeight}:r,[r,t]);useEffect(()=>()=>n(undefined),[t]);let a=useMemo(()=>t?{width:t.width,height:t.height,scaleX:t.naturalWidth/t.width,scaleY:t.naturalHeight/t.height}:undefined,[t]);return {element:t,setElement:o,dimension:a,naturalSize:i}}function ly({images:e,imagesWithFallback:t,height:o}){return jsx(n$1,{alignItems:"center",justifyContent:"center",width:"100%",height:"100%",borderRadius:"s",overflow:"hidden","data-test":"room-images",children:jsxs($l,{showDots:true,dots:jsx(vl,{}),showArrows:true,arrows:jsx(Tl,{}),children:[e&&e.map(r=>jsx(wl,{src:r,maxHeight:o,width:"100%",alt:"image"},r)),t&&t.map(({src:r,fallback:n,crop:i,alt:a})=>jsx(kl,{imageUrl:r,alt:a||"",maxHeight:o,fallback:jsx(Rl,{src:n,cropData:i,maxHeight:o,"aria-label":a||""},r)},r))]})})}function vl(){let{totalPages:e,currentPage:t,goToPage:o}=useCarousel();return jsx(P,{spacing:"s",mt:"sm",children:[...Array(e)].map((r,n)=>jsx(Bl,{onClick:()=>o(n),isActive:n===t,"data-test":`${n+1}-dot`},`${n}-dot`))})}function Tl(){let{currentPage:e,totalPages:t,goBack:o,goForward:r}=useCarousel(),n=e>0,i=e<t-1;return jsxs("div",{children:[jsx(Cn,{p:"none m",visibility:n?"initial":"hidden",children:jsx(x,{icon:"VMSWeb-chevron-left",iconBackgroundColor:"primaryBackground","data-test":"chevron-left",onClick:o})}),jsx(Cn,{p:"none m",isRight:true,visibility:i?"initial":"hidden",children:jsx(x,{icon:"VMSWeb-chevron-right",iconBackgroundColor:"primaryBackground","data-test":"chevron-right",onClick:r})})]})}var fo=({maxHeight:e})=>css`
  object-fit: cover;
  object-position: center center;
  min-width: 100%;
  max-height: ${e||"100%"};
`,wl=Me.img`
  ${e=>fo(e)}
`,kl=Me(dn)`
  ${e=>fo(e)}
`,Rl=Me(ao)`
  ${e=>fo(e)}
`,$l=Me(Carousel)`
  width: 100%;
`,Bl=Me(G)`
  padding: 0;
  width: 8px;
  height: 8px;
  background-color: ${e=>e.isActive?e.theme.colors.brandColor:e.theme.colors.primaryBackground};
  border: ${e=>`${e.theme.borderWidth.s} solid ${e.theme.colors.secondaryFont}`};
`,Cn=Me(a)`
  position: absolute;
  top: calc(50% - 2rem);
  right: ${e=>e.isRight?0:"auto"};
`;var Tn=defineMessages({footerLabel:{id:"footer.label",defaultMessage:"Experience by"},footerImageLabel:{id:"footer.image.label",defaultMessage:"SEVENROOMS"}});var Wl="https://sevenrooms.com";function Sy({showTopBorder:e=true}){let{formatMessage:t}=useLocales(),{footer:{height:o}}=c(),r="s";return jsx(P,{height:o,"data-test":"footer",backgroundColor:"primaryBackground",borderTopColor:e?"borders":undefined,alignItems:"center",justifyContent:"center",width:"100%",p:`${r} none`,spacing:r,tabIndex:0,children:jsx(ExperienceBySevenRooms,{href:Wl,experienceByText:t(Tn.footerLabel)})})}var kn=defineMessages({linkAreaLabel:{id:"logoImage.link.areaLabel",defaultMessage:"{name} logo"}});function Rn({baseUrl:e$1,target:t="_self",logo:o,logoLabel:r,height:n="100%","data-test":i}){let{formatMessage:a}=useLocales();return jsx(Dl,{height:"100%",cursor:"pointer","data-test":i,children:jsx(e,{lineHeight:"none",children:jsx(Link,{"data-test":"logo-link",to:e$1,isExternal:true,target:t,"aria-label":a(kn.linkAreaLabel,{name:r}),children:jsx(ln,{"data-test":"logo-image",src:o,height:n,alt:r,fetchPriority:"high"})})})})}var Dl=Me(a)`
  transition: ${e=>`opacity ${e.theme.animation.duration.logo} ${e.theme.animation.easing.easeInOut}`};

  &:hover {
    opacity: 0.7;
  }
`;function Rt({"data-test":e,ariaLabel:t,width:o,minWidth:r$1,maxWidth:n,maxHeight:i,children:a}){let s=Z.useRef(null),p=typeof o=="number"?`${o}px`:o;return jsx(Al,{onClick:d=>d.stopPropagation(),"data-test":e,role:"dialog","aria-label":t,width:p,maxHeight:i,children:jsx(zl,{children:jsxs(Ol,{pl:"lm",pr:"lm",children:[jsx(r,{}),jsx(_l,{minWidth:r$1,maxWidth:n,width:p,ref:s,children:a})]})})})}var Al=Me.div`
  margin: auto;
  display: flex;
  justify-content: center;
  width: ${({width:e})=>e?`${e}`:"fit-content"};
  max-height: ${({maxHeight:e})=>e??"100%"};
`,Ol=Me(a)`
  display: flex;
  width: 100%;
  max-height: 100%;
`,_l=Me.div`
  display: flex;
  flex-flow: column;
  margin: 0 auto;
  background-color: ${e=>e.theme.colors.primaryBackground};
  width: ${({width:e})=>e?`${e}`:"min-content"};
  min-width: ${({minWidth:e,theme:t})=>e?`${e}`:t.modal.minimalWidth};
  max-width: ${({maxWidth:e,theme:t})=>e?`${e}`:t.modal.maximumWidth};
  box-shadow: ${e=>e.theme.shadows.tertiary};
  border-radius: ${e=>e.theme.modal.borderRadius};
  overflow: auto;
`;function In(e){return jsx(k,{justifyContent:"flex-end",children:jsx(P,{spacing:"s",children:e.children})})}function Kl(e,t){return jsx(TouchScrollable,{children:o=>jsx(a,{pl:"lm",pr:"lm",overflow:"auto",backgroundColor:"primaryBackground",ref:Yn([o,t]),...e,children:e.children})})}var Ln=forwardRef(Kl);function Wn({children:e,...t}){return jsx(Zl,{p:"lm",...t,children:e})}var Zl=Me(a)`
  flex-shrink: 0;
  border-bottom-left-radius: ${e=>e.theme.modal.borderRadius};
  border-bottom-right-radius: ${e=>e.theme.modal.borderRadius};
  background: ${e=>e.theme.colors.primaryBackground};
`;function ed({href:e,size:t,icon:o,iconSize:r,iconColor:n,isExternal:i,...a},s){return jsx(td,{ref:s,to:e,isExternal:i,size:t,borderType:"none-round",...a,children:jsx(e$1,{size:r,name:o,color:n})})}var Fn=forwardRef(ed),td=Me(Link)`
  ${y}
  text-decoration: none;

  // Need to increase specificity to override a global css style applied by
  // nightloop.css. https://sevenrooms.atlassian.net/browse/ORDER-815
  &&:hover {
    text-decoration: none;
  }
  &:active {
    // Override anchor's default browser style for active link
    color: inherit;
  }
`;function $t({children:e,onClose:t,closeHref:o,disabled:r,...n}){return jsxs(od,{pt:"lm",pb:"m",pl:"lm",pr:"m",...n,children:[e,jsx(rd,{children:o?jsx(nd,{href:o,size:"s",icon:"VMSWeb-close",iconColor:"primaryIcons",iconSize:"lg","aria-label":"close","data-test":"ui-kit-modal-close"}):jsx(x,{size:"s",borderType:"none-round",icon:"VMSWeb-close",iconColor:"primaryIcons",onClick:t,"aria-label":"close","data-test":"ui-kit-modal-close",disabled:r})})]})}var od=Me(a)`
  flex-shrink: 0;
  border-top-left-radius: ${e=>e.theme.modal.borderRadius};
  border-top-right-radius: ${e=>e.theme.modal.borderRadius};
  background: ${e=>e.backgroundColor??e.theme.colors.primaryBackground};
  display: flex;
`,rd=Me(a)`
  flex-shrink: 1;
  align-self: start;
  margin-top: -5px;
  margin-left: auto;
`,nd=Me(Fn)`
  &:focus-visible {
    outline: none;
  }
`;function Nn(e$1){return jsxs(n$1,{spacing:"s",flexGrow:1,children:[jsx("div",{children:jsx(M,{type:"h2","data-test":"modal-title",children:e$1.title})}),e$1.subTitle&&jsx("div",{children:jsx(e,{"data-test":"modal-sub-title",children:e$1.subTitle})})]})}var Je=defineMessages({warning:{id:"unsavedChangesModal.warning",defaultMessage:"Unsaved Changes"},title:{id:"unsavedChangesModal.title",defaultMessage:"Are you sure you want to leave without saving?"},back:{id:"unsavedChangesModal.back",defaultMessage:"Back to Editing"},discard:{id:"unsavedChangesModal.discard",defaultMessage:"Exit Without Saving"}});function zS({onCancel:e,onDiscard:t}){let{formatMessage:o}=useLocales();return jsxs(Rt,{ariaLabel:"Modal",minWidth:528,children:[jsx($t,{pb:"none",onClose:()=>e?.(),children:jsxs(n$1,{spacing:"s",children:[jsx(Z$1,{kind:"error",children:o(Je.warning)}),jsx(Nn,{title:o(Je.title)})]})}),jsx(Wn,{children:jsxs(In,{children:[jsx(G,{variant:"secondary",onClick:()=>e?.(),"data-test":"unsaved-modal-cancel",children:o(Je.back)}),jsx(G,{variant:"primary-warning",onClick:()=>t?.(),"data-test":"unsaved-modal-save",children:o(Je.discard)})]})})]})}function nC({fieldArray:e,renderItem:t,item:o,label:r,"data-test":n}){return jsxs(n$1,{"data-test":n,spacing:"s",alignItems:"flex-start",children:[e.map((i,a$1,s)=>jsxs(P,{"data-test":`multiline-item-${s}`,spacing:"s",alignItems:"center",children:[t(i,s),jsx(a,{children:e.size()>1?jsx(x,{"data-test":"multiline-remove",borderType:"none-round",size:"s",icon:"VMSWeb-close",onClick:()=>i.remove()}):jsx(a,{p:"m"})})]},a$1.id)),jsxs(G,{"data-test":"multiline-add",variant:"tertiary",noPadding:true,onClick:()=>e.append(o),children:["+\xA0",r]})]})}function Hn({...e}){return jsx(md,{draggable:false,closeOnClick:false,rtl:false,hideProgressBar:true,...e})}var md=Me(ToastContainer)`
  min-width: 436px;

  @keyframes Toastify__fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes Toastify__fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .Toastify__fade-enter {
    animation: Toastify__fadeIn 0.5s ease-in both;
  }

  .Toastify__fade-exit {
    animation: Toastify__fadeOut 0.5s ease-out both;
  }

  .Toastify__toast-container--bottom-left {
    left: 7em;
  }

  .Toastify__toast {
    min-height: auto;
    padding: ${e=>e.theme.spacing.s} ${e=>e.theme.spacing.m};
    box-shadow: ${e=>e.theme.shadows.secondary};
  }

  .Toastify__toast-body {
    padding: 0;
    font-size: ${e=>e.theme.fontSizes.m};
    line-height: ${e=>e.theme.lineHeights.s};
  }

  .Toastify__toast--error {
    background-color: ${e=>e.theme.colors.error};
  }

  .Toastify__toast--warning {
    background-color: ${e=>e.theme.colors.warning};
  }

  .Toastify__toast--success {
    background-color: ${e=>e.theme.colors.success};
  }

  &.Toastify__toast-container {
    z-index: ${e=>e.theme.zIndex.toaster};
    width: auto;
    min-width: 320px;
    max-width: min-content;
  }

  &.Toastify__toast-body {
    word-break: break-all;
    width: 100%;
  }
`;var Sd=cssTransition({enter:"Toastify__fade-enter",exit:"Toastify__fade-exit"}),Cd={fade:Sd,slide:Slide,bounce:Bounce,zoom:Zoom,flip:Flip};function yC({content:e,type:t="warning",position:o="bottom-left",button:r=jsx(e$1,{name:"VMSWeb-close"}),action:n,autoClose:i=5e3,animation:a="fade",style:s,...p}){let d=r&&(({closeToast:m})=>jsx(Pd,{"data-test":"sr-notification-close-button",variant:"tertiary",onClick:()=>{n?.(),m();},children:r}));toast[t](e,{position:o,closeButton:d,pauseOnHover:true,autoClose:i,style:{zIndex:f.zIndex.toaster,...s},transition:Cd[a],...p});}var Pd=Me(G)`
  padding: 0 ${e=>e.theme.spacing.s};
  color: ${e=>e.theme.colors.lightFont} !important;

  &:focus,
  &:hover,
  &:active {
    color: ${e=>e.theme.colors.lightFont} !important;
  }
`;var vd={info:"dividerLines",error:"error",warning:"warning",success:"success"},Td={info:"primaryIcons",error:"error",warning:"warning",success:"success"},wd={info:"infoBackground",error:"errorBackground",warning:"warningBackground",success:"successBackground"},kd={info:"GX-info-outline",error:"GX-warning",warning:"GX-warning",success:"GX-checkbox-marked-circle"};function BC({content:e$2,type:t,showIcon:o,iconName:r,...n}){return jsxs(Qr,{backgroundColor:wd[t],borderColor:vd[t],flexDirection:"row",alignItems:"center",spacing:"s",p:"m",...n,children:[o&&jsx(k,{alignSelf:"baseline",mt:"xs",children:jsx(e$1,{color:Td[t],size:"lg",name:r??kd[t],"data-test":"notification-banner-icon"})}),jsx(e,{"data-test":"notification-banner-content",wordBreak:"break-word",children:e$2})]})}function An({show:e,children:t,enableAutoFocus:o=true,enableReturnFocus:r$1=false,enableScrollLock:n=true,enableBackdrop:i=true,enableFocusLock:a=true,shouldCloseOnClick:s$1=true,shouldCloseOnEscapePress:p=true,handleFocusableElements:d=false,onBeforeClose:m=he.noop,onEnter:f=he.noop,onEntering:c=he.noop,onEntered:b=he.noop,onExit:u=he.noop,onExiting:y=he.noop,onExited:x=he.noop}){let[S,w]=useState(e?0:2);useEffect(()=>{e&&S===2&&w(0);},[e,S]);function C(R){w(2),x(R);}function k(){m()!==false&&w(1);}function $(R){R.target===R.currentTarget&&s$1&&k();}let L=useTheme(),ne=useMemo(()=>$d.from(L.animation.duration.overlay),[L.animation.duration.overlay]);return S===2?null:jsx(s,{index:L.zIndex.overlay,children:R=>jsx(u$1,{children:jsx(Transition,{appear:true,unmountOnExit:true,in:e&&S!==1,timeout:ne,onEnter:f,onEntering:c,onEntered:b,onExit:u,onExiting:y,onExited:C,children:ge=>jsx(r,{isActive:n,children:jsxs(zl,{disabled:!a,autoFocus:o,returnFocus:r$1,children:[jsx(Dd,{enabled:i,zIndex:R,"data-state":ge,onClick:$,children:typeof t=="function"?t({state:ge,close:k}):t}),jsx(Wd,{handleKeys:["esc"],isDisabled:!p,onKeyEvent:k,handleFocusableElements:d})]})})})})})}var Dd=Me.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${e=>e.zIndex};
  background-color: ${e=>e.enabled?"rgba(10, 10, 10, 0.3)":"transparent"};
  pointer-events: ${e=>e.enabled?"all":"none"};

  > * {
    pointer-events: all;
  }

  ${({theme:{animation:e}})=>css`
    &[data-state='entering'],
    &[data-state='entered'] {
      animation: ${zd} ${e.duration.overlay} ${e.easing.acceleration} both;
    }

    &[data-state='exiting'],
    &[data-state='exited'] {
      animation: ${Ad} ${e.duration.overlay} ${e.easing.deceleration} both;
    }
  `}
`,zd=keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`,Ad=keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;function qC({children:e,...t}){return jsx(Vd,{pl:"m",...t,children:e})}var Vd=Me(a)`
  border-left: 1px solid ${e=>e.theme.colors.dividerLines};
`;var J=defineMessages({noResult:{id:"uikit.select.noResult",defaultMessage:"No result"},emptyItem:{id:"uikit.select.emptyItem",defaultMessage:"Empty item"},filterInput:{id:"uikit.select.filterInput",defaultMessage:"Filter input"},toggleLabel:{id:"uikit.select.toggleLabel",defaultMessage:"Toggle menu"},readerLabel:{id:"uikit.select.readerLabel",defaultMessage:"Choose an element"}});var Vn=memo(forwardRef(qd));function qd({disabled:e,"data-test":t,options:o,withEmpty:r,hideEmptyOption:n,value:i,onChange:a},s){let{formatMessage:p}=useLocales(),d=typeof o[0]?.id=="number",m=useMemo(()=>r&&!n?[null,...o]:[...o],[n,o,r]),f=useMemo(()=>m.find(c=>c?.id===i),[m,i]);return jsxs(Qd,{disabled:e,"data-test":t,tabIndex:-1,ref:s,"aria-hidden":"true",value:f?.id??"",onChange:c=>{let b=c.target.value??null;a?.(b&&d?Number(b):b);},children:[m.map(c=>jsx("option",{value:c?.id??"","aria-label":c?.label||p(J.emptyItem),children:c?.label},c?.id??null)),m.length===0&&jsx("option",{disabled:true,children:p(J.noResult)})]})}var Qd=Me.select`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${e=>e.theme.zIndex.default};
  opacity: 0;
  cursor: ${e=>e.disabled?"not-allowed":"pointer"};

  @media (hover: hover) and (pointer: fine) {
    display: none;
  }
`;function Ee({children:e,"data-test":t="error-message",...o}){return e?jsx(a,{mt:"xs",children:jsx(i,{"data-test":t,...o,children:e})}):null}function xP({"data-test":e,field:t}){let{errors:o}=useFormState({control:t.control}),r=tc(o,t.name);return r.length===0?null:jsx(Ee,{"data-test":e,children:r.join(" ")})}function ec(e){return e!=null}function tc(e,t){if(!e)return [];let o=t.split("."),r=e;for(let n of o)if(r!==undefined&&n in r)r=r[n];else return [];return Un(r)}function oc(e){let t=e.type;return t!==undefined&&typeof t!="object"}function Un(e){if(e){if(oc(e))return [e.message].filter(ec)}else return [];let t,o=[];for(t in e){let r=e[t];o.push(Un(r));}return o.flat()}function sc(e,t){function o(r){typeof e.onClick=="function"&&e.onClick(r);}return jsx(Co,{...e,ref:t,onClick:o,type:"button",children:jsx(e$1,{name:"VMSWeb-chevron-down",color:"primaryIcons"})})}var It=forwardRef(sc),lc=css`
  > i {
    transition-property: transform;
    transition-duration: ${e=>e.theme.animation.duration.controls};
    transition-timing-function: ${e=>e.theme.animation.easing.spring};
    transform: ${e=>e.open?"rotate(180deg)":"rotate(0deg)"};
    font-size: ${e=>e.theme.fontSizes.l};
  }
`,Co=Me.button`
  padding: ${e=>`${e.theme.spacing.sm} ${e.theme.spacing.m} ${e.theme.spacing.sm} ${e.theme.spacing.s}`};
  margin: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${lc}
`;var Fe=memo(forwardRef(gc));function gc({searchable:e=true,disabled:t,invalid:o$1,initialIsOpen:r,initialInputValue:n$2,contentProps:i,placeholder:a,"data-test":s,useSmartAlignment:p$1=true,options:d,withEmpty:m,hideEmptyOption:f,value:c,onChange:b,errorMessage:u,hideErrorMessage:y,zIndexLayer:x="popover",scrollLock:S,filterIcon:w$1,hideFilterIcon:C,onFocus:k,onBlur:$,name:L,withNativeSupport:ne=false,valueIcon:R,displayValue:ge,wrapperProps:it={},alignment:Yt},nr){let{formatMessage:ve}=useLocales(),ir=useRef(null),Zt=useRef(null),ar=useRef([]),[Ue,sr]=useState(false),[at,lr]=useState(false),{ref:dr,width:$a}=pc(),st=useMemo(()=>m&&!f?[null,...d]:[...d],[f,d,m]),{result:Xe,setFilter:qt}=n({options:st,optionToString:Zn,initialFilter:n$2}),Ba=W=>{let H=W?.selectedItem;H!==undefined&&(Zt.current?.focus(),b?.(H?.id??null));},{isOpen:G,openMenu:Qt,closeMenu:cr,inputValue:mr,selectedItem:Te,getToggleButtonProps:pr,getLabelProps:Jt,getMenuProps:Ia,getInputProps:fr,getComboboxProps:gr,highlightedIndex:Ma,getItemProps:La}=useCombobox({items:Xe,itemToString:Zn,circularNavigation:true,onSelectedItemChange:Ba,initialIsOpen:r,initialInputValue:n$2,selectedItem:st.find(W=>W?.id===c)??null,stateReducer:(W,{type:H,changes:V})=>{switch(H){case useCombobox.stateChangeTypes.FunctionOpenMenu:{let Ke=W.selectedItem?st.indexOf(W.selectedItem):undefined;return {...W,...V,inputValue:"",highlightedIndex:Ke}}case useCombobox.stateChangeTypes.InputBlur:case useCombobox.stateChangeTypes.ToggleButtonClick:case useCombobox.stateChangeTypes.FunctionCloseMenu:case useCombobox.stateChangeTypes.FunctionToggleMenu:case useCombobox.stateChangeTypes.ItemClick:case useCombobox.stateChangeTypes.InputKeyDownEnter:case useCombobox.stateChangeTypes.InputKeyDownEscape:{let Ke=(V.selectedItem===null||V.inputValue==="")&&st[0]!==null;return {...W,...V,inputValue:W.selectedItem?.label??"",...Ke?{selectedItem:W.selectedItem}:{}}}case useCombobox.stateChangeTypes.InputChange:return G&&qt(V.inputValue||""),{...W,...V};default:return {...W,...V}}}}),Wa=useCallback(()=>{Te&&ar.current[Xe.indexOf(Te)]?.scrollIntoView?.();},[Xe,Te]),Ea=useCallback(()=>{qt(""),!at&&!Ue&&$?.();},[at,$,qt,Ue]),Fa=useCallback(W=>jsxs(fa,{open:G,invalid:o$1,disabled:t,flipped:W.flipped,focused:Ue||at,...gr({ref:Yn([dr,W.ref])}),"aria-expanded":G?"true":"false","aria-controls":Jt().id,...s&&{"data-test":s},valueIcon:!!R,children:[jsx(da$1,{"aria-label":ve(J.filterInput),tabIndex:Ue?-1:0,searchable:e,selectedValue:Te?.label,displayValue:ge,placeholder:a,filterIcon:w$1,valueIcon:R,hideFilterIcon:C,...s&&{"data-test":`${s}-filter`},...fr({ref:Yn([ir,nr]),name:L,onFocus:()=>{lr(true),k?.(),G||Qt();},onBlur:H=>{lr(false),H.relatedTarget!==Zt.current&&!G&&$?.();},onMouseDown:()=>{e||(G?cr():Qt());},disabled:t,value:mr})}),jsx(It,{...pr({disabled:t,ref:Zt,onFocus:()=>sr(true),onBlur:H=>{sr(false),H.relatedTarget!==ir.current&&!G&&$?.();}}),"aria-label":ve(J.toggleLabel),...s&&{"data-test":`${s}-toggle`},open:G}),jsx(ha$1,{...Jt(),children:i?.["aria-label"]||ve(J.readerLabel)})]}),[cr,i,t,ge,w$1,at,ve,gr,fr,Jt,pr,C,mr,o$1,G,L,$,k,Qt,a,nr,e,Te?.label,dr,s,Ue,R]),Na=Ia({},{suppressRefError:true});return jsxs(n$1,{position:ne?"relative":"static",...it,children:[jsx(w,{show:G,content:({flipped:W})=>jsxs(p,{width:R?212:$a,flipped:W,...Na,children:[Xe.map((H,V)=>jsx(q$1,{"aria-label":H?.label??ve(J.emptyItem),label:H?.label,selected:Te===H,highlighted:Ma===V,...La({item:H,index:V,ref:Ke=>{ar.current[V]=Ke;}})},H?.id??"empty-item")),Xe.length===0&&jsx(o,{children:ve(J.noResult)})]}),onOpen:Wa,onCloseComplete:Ea,alignment:Yt,targetOffset:0,bodyOffset:0,contentProps:i,useSmartAlignment:p$1,zIndexLayer:x,scrollLock:S,"data-test":s?`${s}-popover`:undefined,children:Fa}),!y&&jsx(Ee,{children:u}),ne&&!e&&jsx(Vn,{value:c,options:d,disabled:t,onChange:b,"data-test":`${s}-native`,withEmpty:m,hideEmptyOption:f})]})}function Zn(e){return e?.label??""}var _P=e=>Object.entries(e).map(([t,o])=>({id:t,label:o}));var UP=({max:e,start:t=1,step:o=1,suffix:r="",prefix:n=""})=>{let i=[];for(let a=t;a<=e;a+=o)i.push({id:String(a),label:`${n}${a}${r}`});return i};function qn({items:e,anchor:t,...o}){let[r,n]=useState(false),{ref:i,width:a}=pc(),s=css`
    width: ${a}px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: 1px solid ${p=>p.theme.colors.deactivated};
  `;return jsx(A,{onOpen:()=>n(true),onClose:()=>n(false),anchor:jsxs(bc,{open:r,children:[jsx(yc,{pl:"m",children:t}),jsx(Sc,{open:r})]}),anchorRef:i,rowsStyles:s,targetOffset:"none",...o,children:e.map(p=>jsx(z,{onClick:p.onClick,children:p.label},p.id))})}var bc=Me(fa)`
  cursor: pointer;
`,yc=Me(a)`
  flex: 1;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
`,Sc=Me(It)`
  pointer-events: none;
`;function Sv({width:e$1,isShowingSideNavigation:t=true,venueOptions:o,selectedVenueId:r,onVenueChange:n,profileOptions:i,user:a$1}){let{formatMessage:s}=useLocales(),p=d=>jsxs(k,{maxWidth:"170px",alignItems:"center",children:[jsx(a,{mr:"sm",children:jsx(zr,{firstName:d.first_name,lastName:d.last_name,image:d.photo?.small?`/.h/download/${d.photo.small}`:undefined})}),jsx(e,{textOverflow:"ellipsis",overflow:"hidden",children:d?.first_name})]});return jsxs(wc,{justifyContent:"space-between",width:e$1,isShowingSideNavigation:t,children:[jsx(k,{height:"100%",alignItems:"center",ml:"lm"}),jsxs(P,{height:"100%",spacing:"s",alignItems:"center",justifyContent:"flex-end",mr:"s",children:[jsx(Fe,{options:o,value:r??null,withEmpty:true,hideEmptyOption:true,onChange:n,placeholder:r?undefined:s(commonMessages.loadingVenues),"data-test":"sr-primary-header-venue-menu"}),a$1&&i&&jsx(kc,{children:jsx(qn,{anchor:p(a$1),items:i,"data-test":"sr-primary-header-user-menu"})})]})]})}var Tc=58,wc=Me(k)`
  width: ${e=>e.width||`calc(100% - (${e.theme.sizes.tabsNavWidth} + ${e.isShowingSideNavigation?e.theme.sizes.sideNavWidth:"0px"}))`};
  height: ${Tc}px;
  position: fixed;
  top: 0;
  background: ${e=>e.theme.colors.primaryBackground};
  z-index: ${f.zIndex.navbar};
  box-sizing: border-box;
`,kc=Me.div`
  flex-basis: 140px;
`;var Bc="secondary-header";function Fv({title:e,breadcrumbs:t,description:o,image:r,tab:n,actions:i,top:a$1=0,width:s,maxWidth:p,textMaxWidth:d="640px",onHeightChange:m,isAdmin:f,backgroundImage:c,isShowingSideNavigation:b=true}){let[u,y]=Z.useState(false),x=s$1(u),S=useTheme(),{ref:w,height:C}=D(50,"border-box"),{y:k$1}=B({y:f?50:j$1(S.spacing.lm)}),{height:$,opacity:L}=useSpring({opacity:u?0:1,height:u?"0%":"100%",config:{duration:150}}),{display:ne,lineHeight:R,fontSize:ge,padding:it}=useSpring({display:u?"initial":"none",lineHeight:u?S.lineHeights.l:S.lineHeights.xl,fontSize:u?S.fontSizes.xl:S.fontSizes.xxl,padding:u?S.spacing.s:S.spacing.lm,config:{duration:150}});return Z.useEffect(()=>{y(k$1);},[k$1]),Z.useEffect(()=>{he.isNumber(C)&&m?.(C);},[C,m]),jsxs(Ec,{id:Bc,"data-test":"secondary-header",style:{paddingTop:it,paddingBottom:it},ref:w,top:f&&k$1?0:a$1,collapsed:u,pl:"lm",pr:"lm",width:s,backgroundImage:c,isShowingSideNavigation:b,children:[t,jsxs(P,{maxWidth:p,justifyContent:"space-between",alignItems:"center",flexGrow:1,ml:f?"auto":"none",mr:f?"auto":"none",mt:t?"m":"none",children:[jsx(k,{alignSelf:"flex-start",children:jsxs(P,{spacing:"m",alignItems:"center",children:[r&&jsx(Lc,{children:r}),jsxs(n$1,{spacing:o&&!u?"s":undefined,alignItems:f?"flex-start":undefined,maxWidth:d,children:[jsxs(k,{alignItems:"center",children:[jsx(a,{mt:u?"s":undefined,mb:u?"s":undefined,children:jsx(jn,{"data-test":"secondary-header-title",style:{lineHeight:R,fontSize:ge,fontWeight:"bold"},children:e})}),n&&jsxs(jn,{style:{display:ne,lineHeight:S.lineHeights.l,fontSize:S.fontSizes.xl},children:["\xA0-\xA0",n]})]}),jsx(Fc,{style:{opacity:L,height:u&&x===u?$:"auto",display:L.to(Yt=>Yt===0?"none":"initial")},children:jsx(j,{children:o})})]})]})}),i&&jsx(k,{alignSelf:"flex-start",children:jsx(Mc,{children:i})})]})]})}var Ic=Me(a)`
  ${e=>e.backgroundImage&&css`
      background: ${e.backgroundImage};
    `}

  width: ${e=>e.width||`calc(100% - (${e.theme.sizes.tabsNavWidth} + ${e.isShowingSideNavigation?e.theme.sizes.sideNavWidth:"0px"}))`};
  box-sizing: border-box;
  background-color: ${e=>e.theme.colors.secondaryBackground};
  position: fixed;
  top: ${e=>`${e.top||0}px`};
  z-index: ${e=>e.theme.zIndex.navbar};
  min-height: 58px;

  ${e=>e.isAdmin&&css`
      left: 0;
    `}

  ${e=>e.collapsed&&css`
      box-shadow: ${e.theme.shadows.primary};
    `};
`,Mc=Me(a)`
  min-height: ${e=>e.theme.fieldHeight.m};
`,Lc=Me(a)``,Wc=Me(a)`
  line-height: ${e=>`${e.lineHeight} !important`};
  font-size: ${e=>`${e.fontSize} !important`};
`,jn=animated(Wc),Ec=animated(Ic),Fc=Me(animated.div)`
  will-change: opacity, height;
  overflow: hidden;
`;var ei=createGlobalStyle`
  .DayPicker {
    font-size: ${e=>e.theme.fontSizes.m};
    font-family: ${e=>e.theme.fonts.primary};

    &_weekHeader {
      color: ${e=>e.theme.colors.primaryFont};
    }

    &_focusRegion {
      box-shadow: ${e=>e.theme.shadows.tertiary};
    }

    .CalendarMonth_caption {
      color: ${e=>e.theme.colors.primaryFont};
      margin-bottom: ${e=>e.theme.spacing.s};
    }

    .CalendarDay {
      font-weight: 300;
      color: ${e=>e.theme.colors.primaryFont};
      border: 1px solid ${e=>e.theme.colors.dividerLines};

      &__highlighted_calendar {
        font-weight: bold;
        &:not(.CalendarDay__selected):not(:hover) {
          background-color: ${e=>e.theme.colors.primaryBackground};
        }
      }

      &__blocked_out_of_range {
        color: ${e=>e.theme.colors.deactivated};
      }

      &__default {
        &:hover {
          background-color: ${e=>e.theme.colors.dividerLines};
        }
      }

      &__selected {
        background-color: ${e=>e.theme.colors.primaryButton};
        border-color: ${e=>e.theme.colors.primaryButton};
        color: ${e=>e.theme.colors.lightFont};

        &:hover {
          background-color: ${e=>e.theme.colors.primaryHover};
        }
      }

      &__today {
        border: 1px solid ${e=>e.theme.colors.primaryButton};
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          height: calc(100% + 2px);
          background-color: ${e=>e.theme.colors.primaryButton};
          width: 1px;
        }

        &:after {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          height: 1px;
          background-color: ${e=>e.theme.colors.primaryButton};
          width: calc(100% + 1px);
        }
      }

      &__blocked_calendar {
        position: relative;
        background-color: ${e=>e.theme.colors.secondaryFont};
        border-color: ${e=>e.theme.colors.secondaryFont};
        color: ${e=>e.theme.colors.lightFont};

        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          height: calc(100% + 2px);
          background-color: ${e=>e.theme.colors.secondaryFont};
          width: 1px;
        }

        &:after {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          height: 1px;
          background-color: ${e=>e.theme.colors.secondaryFont};
          width: calc(100% + 1px);
        }

        &:hover {
          background-color: ${e=>e.theme.colors.secondaryFont};
        }
      }
    }

    th,
    td {
      border: none;
      padding: 0;
    }
  }

  .DayPickerNavigation {
    display: flex;
    justify-content: space-between;
  }
`;function ri({small:e}){let{formatMessage:t}=useLocales();return e?jsx(zc,{name:t(commonMessages.next),children:jsx(e$1,{name:"VMSWeb-chevron-right"})}):jsx(Dc,{name:t(commonMessages.next),borderType:"none-round",icon:"VMSWeb-chevron-right"})}var Dc=Me(x)`
  margin-top: 10px;
  margin-right: ${e=>e.theme.spacing.m};
`,zc=Me(E$1)`
  margin-top: 23px;
  margin-right: ${e=>e.theme.spacing.s};
`;function ai({small:e}){let{formatMessage:t}=useLocales();return e?jsx(_c,{name:t(commonMessages.previous),children:jsx(e$1,{name:"VMSWeb-chevron-left"})}):jsx(Oc,{name:t(commonMessages.previous),borderType:"none-round",icon:"VMSWeb-chevron-left"})}var Oc=Me(x)`
  margin-top: 10px;
  margin-left: ${e=>e.theme.spacing.m};
`,_c=Me(E$1)`
  margin-top: 23px;
  margin-left: ${e=>e.theme.spacing.s};
`;function di({onFocusChange:e,small:t,noBorder:o=false,forceFocus:r=false,onDateChange:n,isDayHighlighted:i,date:a,...s}){let[p,d]=Z.useState(false),m=({focused:c})=>{d(c),e?.({focused:c});},f=c=>{n?.(c?.toDate()||null);};return jsxs(Fragment,{children:[jsx(ei,{}),jsx(Uc,{small:t,noBorder:o,children:jsx(DayPickerSingleDateController,{...s,date:a?Mo(a):null,onDateChange:f,isDayHighlighted:i?c=>i(c.toDate()):undefined,focused:r||p,onFocusChange:m,numberOfMonths:1,hideKeyboardShortcutsPanel:true,navPrev:jsx(ai,{small:t}),navNext:jsx(ri,{small:t}),daySize:t?24:40,noBorder:o,initialVisibleMonth:()=>a?Mo(a):Mo()},a?a.getTime():null)})]})}var Uc=Me.div`
  ${e=>e.small&&css`
      .DayPicker {
        width: 184px !important;
        .CalendarDay {
          font-size: ${e.theme.fontSizes.xs};
          font-weight: 300;

          &__highlighted_calendar {
            font-weight: bold;
            &:not(.CalendarDay__selected):not(:hover) {
              background-color: ${e.theme.colors.primaryBackground};
            }
          }
        }
        .CalendarMonthGrid {
          left: 8px;
        }
        &_transitionContainer,
        &_focusRegion {
          width: 184px !important;
        }
        .CalendarMonth {
          padding: 0 !important;
          &_caption {
            font-size: ${e.theme.fontSizes.l};
            padding-top: ${e.theme.spacing.lm};
            padding-bottom: 28px;
          }
        }
        &_weekHeader {
          padding: 0 !important;
          top: 50px;
        }
      }
    `}

  ${e=>e.noBorder&&css`
      .DayPicker_focusRegion {
        box-shadow: none;
      }
    `}
`;var He=Me(e)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;function ci({title:e,id:t,to:o}){let r=useLocation(),n=!!matchPath(r.pathname,{path:o,exact:false,strict:false,sensitive:false});return jsx(R,{"data-test":t,to:o,children:jsx(Jc,{pl:"m",pr:"s",pb:"xs",pt:"xs",mb:"xxs",children:jsx(He,{color:"secondaryFont",textStyle:n?"body2Medium":"body2",children:e})})})}var Jc=Me(a)`
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${e=>e.theme.colors.secondaryBackground};
  }
`;function Lt(e,t){let o=useLocation(),r=useMemo(()=>!!e.find(({to:n})=>!!matchPath(o.pathname,{path:n,exact:false,strict:false,sensitive:false})),[e,o.pathname]);return useState(r?false:t)}var mi='data:image/svg+xml,<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="14" height="14" rx="7" fill="white"/>%0A<path d="M7 9.635L10.09 11.5L9.27 7.985L12 5.62L8.405 5.31L7 2L5.595 5.31L2 5.62L4.725 7.985L3.91 11.5L7 9.635Z" fill="%23FEC636"/>%0A</svg>%0A';function ui({items:e$2,title:t,to:o,id:r,premium:n,reload:i,collapsedState:a,setCollapsedState:s,exact:p}){let d=useLocation(),{formatMessage:m}=useLocales(),f=useMemo(()=>!!matchPath(d.pathname,{path:o?.split("?")[0]??"",exact:p??false,strict:false,sensitive:false}),[o,p,d.pathname]),[c,b]=Lt(e$2,!!a[r]),u=()=>{b(!c),s({...a,[r]:!c});};return jsxs(Fragment,{children:[(()=>{let x=jsxs(dm,{mb:"xxs",pl:"s",pr:"xs",pt:"xs",pb:"xs",justifyContent:"space-between",alignItems:"center",onClick:u,active:f,children:[jsxs(k,{flexDirection:"row",children:[jsx(He,{textStyle:f?"body2Medium":"body2",color:f?"primaryNavigation":"secondaryFont",children:t}),n&&jsx("img",{src:mi,width:12,alt:"premium",style:{marginLeft:4}})]}),!he.isEmpty(e$2)&&jsx(E$1,{"aria-label":m(commonMessages.collapse),name:m(commonMessages.collapse),children:jsx(e,{fontSize:"l",children:jsx(e$1,{color:"primaryIcons",name:c?"VMSWeb-chevron-down":"VMSWeb-chevron-up"})})})]});return i?jsx(cm,{"data-test":r,href:o,children:x}):jsx(R,{"data-test":r,to:o,children:x})})(),jsx(de,{collapsed:c,"data-test":`${r}-collapsible`,children:e$2.map(x=>x.allowed!==false&&createElement(ci,{...x,key:x.id}))})]})}var dm=Me(k)`
  cursor: pointer;
  border-radius: 4px;

  ${e=>e.active?css`
          background-color: ${t=>t.theme.colors.margin};
        `:css`
          &:hover {
            background-color: ${t=>t.theme.colors.secondaryBackground};
          }
        `}
`,cm=Me.a`
  color: inherit !important;
  text-decoration: none !important;
`;function bi({title:e$2,items:t,id:o,collapsible:r=true,collapsedState:n,setCollapsedState:i}){let{formatMessage:a$1}=useLocales(),[s,p]=Lt(t,!!n[o]);return jsxs(Fragment,{children:[jsxs(um,{justifyContent:"space-between",alignItems:"center",onClick:r?()=>{p(!s),i({...n,[o]:!s});}:undefined,mb:"xs",pr:"xs",children:[jsx(He,{textStyle:"body2Medium",color:"primaryNavigation",children:e$2}),r&&jsx(E$1,{"aria-label":a$1(commonMessages.collapse),name:a$1(commonMessages.collapse),children:jsx(e,{fontSize:"l",children:jsx(e$1,{color:"primaryIcons",name:s?"VMSWeb-chevron-down":"VMSWeb-chevron-up"})})})]}),jsx(a,{mb:"s",children:jsx(de,{collapsed:s,"data-test":`${o}-collapsible`,children:t.map(m=>m.allowed!==false&&createElement(ui,{...m,key:m.id,collapsedState:n,setCollapsedState:i}))})})]})}var um=Me(k)`
  cursor: pointer;
`;var bw=Me.input`
  position: absolute;
  margin: 0;
  opacity: 0;
  padding: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  white-space: nowrap;
`;var Ci=forwardRef(Cm);function Cm({"data-test":e,border:t,disabled:o,errorMessage:r,fieldHeight:n,fullWidth:i,textTransform:a,hideErrorMessage:s,invalid:p,name:d,onBlur:m,onFocus:f,prefix:c,suffix:b,value:u,...y},x){let[S,w]=useState(false),C=useCallback(L=>{w(false),m?.(L);},[m]),k=useCallback(L=>{w(true),f?.(L);},[f]),$=e??d;return jsxs(n$1,{spacing:"xs",width:"100%","data-test":$?`${$}-container`:undefined,children:[jsxs(Pm,{fullWidth:i,alignItems:"center",textTransform:a,disabled:o,border:t,isFocused:S,invalid:p,fieldHeight:n,children:[c&&jsx(vm,{children:c}),jsx("input",{...y,"data-test":$,name:d,value:u,ref:x,onFocus:k,onBlur:C,disabled:o}),b&&jsx(Tm,{children:b})]}),!s&&jsx(Ee,{children:r})]})}var Pm=Me(P)`
  ${e=>css`
    width: 100%;
    max-width: ${e.fullWidth?"100%":e.theme.sizes.fieldMaxWidth};
    background: ${e.theme.colors.inputBackground};
    padding: 0 ${e.fieldHeight==="xs"?e.theme.spacing.s:e.theme.spacing.m};
    border-radius: 4px;
    height: ${e.theme.fieldHeight[e.fieldHeight||"m"]};
    box-sizing: border-box;
    color: ${e.theme.colors.primaryFont};
    font: ${e.fieldHeight==="xs"?e.theme.textStyles.body2:e.theme.textStyles.body1};
    border: ${`1px solid ${e.theme.colors.borders}`};

    &:hover {
      border-color: ${e.disabled?e.theme.colors.borders:e.theme.colors.borderHover};
    }

    &:active {
      border-color: ${e.disabled?e.theme.colors.borders:e.theme.colors.borderFocus};
    }

    &::placeholder {
      color: ${e.theme.colors.secondaryFont};
    }
  `}

  ${e=>e.isFocused&&css`
      && {
        outline: none;
        border-color: ${e.theme.colors.borderFocus};

        ${e.disabled&&css`
          border-color: ${e.theme.colors.borders};
        `}
      }
    `}

  ${e=>e.disabled&&css`
      color: ${e.theme.colors.secondaryFont};
      background-color: ${e.theme.colors.secondaryBackground};
    `}

  ${e=>e.invalid&&css`
      border-color: ${e.theme.colors.error};
    `}

  ${e=>e.border&&css`
      border: ${e.border};
    `}

  & input {
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    background: inherit;
    color: inherit;
    outline: none;
    font-size: inherit;
    font-weight: inherit;

    ${e=>e.textTransform&&css`
        text-transform: ${e.textTransform};
      `}
  }
`,vm=Me.div`
  padding-right: 4px;
`,Tm=Me.div`
  padding-left: 4px;
`;var Fo=defineMessages({placeholder:{id:"sideNavigationSearch.placeholder",defaultMessage:"Search Settings..."},noResultLabel:{id:"sideNavigationSearch.noResultLabel",defaultMessage:"Nothing Found"}});function Ti({items:e$1}){let t=useLocation(),o=useTheme(),{formatMessage:r}=useLocales(),n$1=useMemo(()=>Fm(e$1),[e$1]),i=useMemo(()=>Number.parseInt(o.sizes.sideNavWidth)-Number.parseInt(o.sizes.sideNavPadding)*2,[o.sizes.sideNavPadding,o.sizes.sideNavWidth]),{result:a,setFilter:s}=n({options:n$1,optionToString:vi}),{isOpen:p,setInputValue:d,inputValue:m,getMenuProps:f,getInputProps:c,getComboboxProps:b,highlightedIndex:u,getItemProps:y}=useCombobox({items:a,itemToString:vi,circularNavigation:true,onInputValueChange:C=>{C.isOpen&&s(C.inputValue??"");},onIsOpenChange:C=>{C.isOpen||d("");},onSelectedItemChange:({selectedItem:C})=>{C?.to&&window.location.replace(C.to);}}),x=f({},{suppressRefError:true}),S=({flipped:C})=>jsxs(Lm,{width:i,flipped:C,...x,children:[a.map((k,$)=>jsx(Em,{pt:"xs",pb:"xs",pr:"s",pl:k.items?"s":"m",highlighted:u===$,...y({item:k,index:$}),children:jsx(e,{textStyle:matchPath(t.pathname,k.to)?.isExact?"body2Medium":"body2",color:k.items?"primaryFont":"secondaryFont",children:k.title})},k.id)),a.length===0&&jsx(Wm,{children:r(Fo.noResultLabel)})]}),w$1=useCallback(C=>jsx("div",{...b({ref:C.ref}),children:jsx(Ci,{"data-test":"sr-side-navigation-search",fieldHeight:"xs",placeholder:r(Fo.placeholder),...c({value:m})})}),[r,b,c,m]);return jsx(w,{show:p,content:S,alignment:"bottom",targetOffset:2,bodyOffset:0,useSmartAlignment:true,children:w$1})}var Lm=Me(p)`
  border-radius: 4px;
  overflow-y: auto;
`,Wm=Me(o)`
  font: ${e=>e.theme.textStyles.body2};
`,Em=Me(k)`
  background: ${e=>e.highlighted?e.theme.colors.margin:e.theme.colors.primaryBackground};
`,Fm=e=>{let t=[];return e.filter(o=>o.allowed!==false).forEach(o=>{o.items.filter(r=>r.allowed!==false).forEach(r=>{t=[...t,r,...r.items.filter(n=>n.allowed!==false)];});}),t},vi=e=>{let t=e?.title??"";return e?.keywords&&(t=`${t} ${e.keywords.join(" ")}`),t};function ki({venue:e$1,user:t="",items:o,calendar:r,hideVenueName:n=false,hideSearch:i=false,...a}){let s=useTheme(),[p,d]=useState(false),m=useRef(null),{y:f}=B({y:0,ref:m}),[c,b]=o$1({},`sideNavigationCollapsedState_${t}`);useEffect(()=>{d(f);},[f]);let u=s.sizes.sideNavPadding;return jsxs(_m,{...a,children:[!n&&jsx(Vm,{padding:u,children:jsx(e,{color:"secondaryFont",textTransform:"uppercase",fontWeight:"bold",children:he.unescape(e$1)})}),r&&jsx(P,{height:"251px",justifyContent:"center",children:jsx(di,{date:r.date,onDateChange:y=>r?.onDateChange?.(y),isDayHighlighted:r.isDayHighlighted,forceFocus:true,small:true,noBorder:true})}),!i&&jsx(Gm,{mt:"s",padding:u,lifted:p,children:jsx(Ti,{items:o})}),jsx(Um,{padding:u,lifted:p,ref:m,children:o.map(y=>y.allowed!==false&&createElement(bi,{...y,key:y.id,collapsedState:c,setCollapsedState:b}))})]})}var _m=Me(n$1)`
  width: ${e=>e.theme.sizes.sideNavWidth};
  height: 100%;
  max-height: 100vh;
  top: 0;
  position: fixed;
  box-sizing: border-box;
  border-right: 1px solid ${e=>e.theme.colors.dividerLines};
  background: ${e=>e.theme.colors.primaryBackground};
  z-index: ${e=>e.theme.zIndex.navbar};
`,Vm=Me(a)`
  height: ${e=>e.theme.fieldHeight.m};
  margin-top: ${e=>e.theme.sizes.sideNavPadding};
  padding: 0 ${e=>e.padding};
  flex-shrink: 0;
`,Gm=Me(a)`
  padding: 0 ${e=>e.padding} ${e=>e.theme.spacing.lm};
  ${e=>e.lifted&&css`
      box-shadow: ${e.theme.shadows.primary};
    `};
`,Um=Me(a)`
  overflow-y: auto;
  padding: 0 ${e=>e.padding} ${e=>e.theme.spacing.s};
  ${e=>e.lifted&&css`
      border-top: 1px solid ${e.theme.colors.dividerLines};
    `};
`;var Se=defineMessages({rowsPerPage:{id:"uikit.pagination.rowsPerPage",defaultMessage:"Rows per page:"},pagesCount:{id:"uikit.pagination.pagesCount",defaultMessage:"{start}-{end} of {total} items"},firstPage:{id:"uikit.pagination.firstPage",defaultMessage:"First page"},backPage:{id:"uikit.pagination.backPage",defaultMessage:"back"},nextPage:{id:"uikit.pagination.nextPage",defaultMessage:"Next"},lastPage:{id:"uikit.pagination.lastPage",defaultMessage:"Last page"}});var Qm=[10,20,30,40],Jm=Qm.map(e=>({id:e.toString(),label:e.toString()}));function Ri(e$1){let{formatMessage:t}=useLocales(),o=e$1.options?.length?e$1.options:Jm,[r,n]=useState((o.find(s=>s.id===e$1.rowsPerPage.toString())??o[0]).id),i=typeof e$1.totalItemsCount=="number"?Math.min(e$1.rowsPerPage*e$1.currentPage,e$1.totalItemsCount):e$1.rowsPerPage*e$1.currentPage,a$1=s=>{n(s),e$1.onPerPageChange(parseInt(s));};return jsxs(k,{alignItems:"center",children:[jsx(a,{pr:"m",children:jsx(e,{children:t(Se.rowsPerPage)})}),jsx("div",{style:{width:90},children:jsx(Fe,{options:o,value:r,onChange:a$1,searchable:false})}),jsx(a,{pl:"l",pr:"l",children:jsx(e,{children:t(Se.pagesCount,{start:e$1.rowsPerPage*e$1.currentPage-e$1.rowsPerPage+1,end:i,total:e$1.totalItemsCount})})}),jsx(x,{borderType:"none-round",icon:"VMSWeb-page-first","data-test":"ui-kit-pagination-first",onClick:()=>e$1.goToPage("first"),disabled:!e$1.canPreviousPage,title:t(Se.firstPage)}),jsx(x,{borderType:"none-round",icon:"VMSWeb-chevron-left","data-test":"ui-kit-pagination-prev",onClick:()=>e$1.goToPage("prev"),disabled:!e$1.canPreviousPage,title:t(Se.backPage)}),jsx(x,{borderType:"none-round",icon:"VMSWeb-chevron-right","data-test":"ui-kit-pagination-next",onClick:()=>e$1.goToPage("next"),disabled:!e$1.canNextPage,title:t(Se.nextPage)}),!e$1.hideLastPage&&jsx(x,{borderType:"none-round",icon:"VMSWeb-page-last","data-test":"ui-kit-pagination-last",onClick:()=>e$1.goToPage("last"),disabled:!e$1.canNextPage,title:t(Se.lastPage)})]})}function Fk(e$1){return jsxs(Tt,{gridTemplateColumns:"repeat(12, 1fr)",gap:"lm",gridAutoRows:"min-content",children:[jsx(a,{maxWidth:"100%",gridColumn:"auto / span 4",children:jsx(e,{fontSize:"m",children:e$1.left})}),jsx(a,{maxWidth:"100%",gridColumn:"auto / span 8",children:jsx(e,{fontSize:"m",textOverflow:e$1.textOverflow,children:e$1.right})})]})}function tp({primary:e$1,secondary:t,label:o,onClick:r}){return jsxs(n$1,{p:"lm",children:[jsx(M,{type:"h2",children:e$1}),jsx(a,{pt:"m",children:jsx(e,{children:t})}),o&&r&&jsx(k,{justifyContent:"flex-end",pt:"l",pb:"s",children:jsx(Bi,{"data-test":`sr-${o}-button`,variant:"secondary",size:"s",onClick:r,children:o})})]})}function op({primary:e,secondary:t,label:o,onClick:r}){return jsxs(P,{pt:"m",pb:"m",pl:"lm",pr:"lm",spacing:"3xl",children:[jsxs(n$1,{flexGrow:1,children:[jsx(M,{type:"h2",children:e}),jsx(a,{pt:"xs",children:jsx(j,{children:t})})]}),o&&r&&jsx(k,{alignItems:"center",children:jsx(Bi,{"data-test":`sr-${o}-button`,variant:"secondary",size:"s",onClick:r,children:o})})]})}function Yk({size:e="l",...t}){return jsx(np,{size:e,children:e==="s"?jsx(tp,{...t}):jsx(op,{...t})})}var rp={xl:"968px",l:"920px",s:"448px"},np=Me(a)`
  max-width: ${e=>rp[e.size]};
  background-color: ${e=>e.theme.colors.margin};
  border-radius: 10px;
  box-shadow: ${e=>e.theme.shadows.primary};
`,Bi=Me(G)`
  background-color: ${e=>e.theme.colors.inputBackground};
`;function e0(e){return jsx(ip,{children:jsx(ap,{children:e.children})})}var ip=Me.table`
  background: inherit;
  width: 100%;
  border: none;
  border-spacing: 0;
  border-collapse: separate;
`,ap=Me.tbody`
  background: inherit;
`;function s0(e$1){let{count:t$1,clearChildren:o}=t(e$1.children);return t$1===0?null:jsxs(sp,{children:[jsx(lp,{firstColWidth:e$1.firstColWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:e$1.name})})}),Array.isArray(o)?o.map((r,n)=>jsx(Do,{colWidth:e$1.colWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:r})})},n)):jsx(Do,{colWidth:e$1.colWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:o})})})]})}var sp=Me.tr``,Do=Me.td`
  border: none;
  padding: 0;
  border-bottom: 1px solid ${e=>e.theme.colors.dividerLines};
  width: ${e=>e.colWidth??"initial"};
  vertical-align: top;
`,lp=Me(Do)`
  width: ${e=>e.firstColWidth??"324px"};
`;function g0(e$1){let{count:t$1,clearChildren:o}=t(e$1.children);return t$1===0?null:jsxs(Fragment,{children:[e$1.caption!==undefined&&jsx(cp,{position:e$1.position,children:Array.isArray(e$1.caption)?e$1.caption.map((r,n)=>jsx(Li,{children:jsx(a,{p:"xs",children:jsx(e,{fontWeight:"bold",children:r})})},n)):jsx(Li,{colSpan:2,children:jsx(a,{p:"xs",children:jsx(e,{fontWeight:"bold",children:e$1.caption})})})}),o,jsx(mp,{children:jsx(Wi,{children:jsx(a,{p:"m"})})})]})}var cp=Me.tr`
  position: ${e=>e.position||"sticky"};
  top: 0;
  background: inherit;
`,Wi=Me.td`
  border: none;
  padding: 0;
`,Li=Me(Wi)`
  border-bottom: 2px solid ${e=>e.theme.colors.dividerLines};
`,mp=Me.tr`
  :last-child {
    display: none;
  }
`;function T0(e){return jsxs(gp,{children:[jsx(up,{pl:"m",pr:"m",pt:"s",pb:"s",children:jsx(M,{type:"h4",children:e.title})}),jsx(hp,{p:"m",children:e.children})]})}var Oo="4px",gp=Me.div`
  background: ${e=>e.theme.colors.secondaryBackground};
  border-radius: ${Oo};
`,up=Me(a)`
  background: ${e=>e.theme.colors.dividerLines};
  border-top-left-radius: ${Oo};
  border-top-right-radius: ${Oo};
`,hp=Me(a)`
  background: inherit;
`;var[Ei,Fi]=a$1();function Di(e){let t=useTheme(),o=Fi(),[r,n]=Z.useState([]),i=r.length>0,a=Z.useCallback(c=>{n(b=>[...b,c]);},[]),s=Z.useCallback(c=>{n(b=>b.filter(u=>u.key!==c.key));},[]),d=useTransition(r,{key:c=>c.key,config:{duration:150},from:{opacity:0,transform:"translateY(0px)",pointerEvents:"none"},enter:{opacity:1,transform:`translateY(${t.modal.topOffset}px)`,pointerEvents:"all"},leave:{opacity:0,transform:"translateY(0px)",pointerEvents:"none"},update:(c,b)=>({opacity:b===r.length-1?1:0,transform:`translateY(${b===r.length-1?t.modal.topOffset:0}px)`,pointerEvents:b===r.length-1?"all":"none"})})((c,b)=>o.dom&&jsx(vp,{ref:b.setNode,style:{transform:c.transform,opacity:c.opacity,pointerEvents:c.pointerEvents}},b.key)),m=Z.useMemo(()=>({register:a,unregister:s,hasOpenedItems:i}),[a,s,i]),f=Z.useCallback(()=>{r.at(-1)?.close();},[r]);return Z.useEffect(()=>{let c=b=>{b.code==="Escape"&&f();};return document.addEventListener("keydown",c),()=>{document.removeEventListener("keydown",c);}},[f,r]),jsxs(Pp,{value:m,children:[o.dom&&Hi.createPortal(jsx(Vr,{onClick:f,isActive:i,"data-test":"ui-kit-backdrop",children:d}),o.dom),e.children]})}var [Pp,zi]=a$1(),vp=Me(animated.div)`
  position: absolute;
  display: flex;
  will-change: transform, opacity, pointer-events;
  width: 100%;
  height: calc(100% - ${e=>e.theme.modal.topOffset*2}px);
`;var Wp={vx:vmsTheme,gx:gxTheme},Ep={vx:e$2,gx:h$1},Fp={vx:d,gx:g$1};function j0({children:e,theme:t,themeOverride:o,locale:r,messages:n}){let[i,a]=Z.useState(null),s=Z.useMemo(()=>({dom:i}),[i]),p=useMemo(()=>Ep[t](he.merge(Fp[t],o)),[t,o]);return jsx(LocaleRoot,{locale:r,messages:n,children:jsx(ThemeProvider,{theme:p,children:jsxs(ThemeProvider$1,{theme:Wp[t],children:[jsx(Normalize,{}),jsxs(Ei,{value:s,children:[jsx(Di,{children:e}),jsx("div",{"data-test":"ui-kit-portal-root",ref:a})]}),jsx(Hn,{})]})})})}function sR(e){let t=useRef(null),[o,r]=useState(1);return useLayoutEffect(()=>{let n=1,i=t.current?.parentElement;i&&(e.scaleWidth&&!e.scaleHeight?(n=Math.min(t.current.parentElement.offsetWidth/t.current?.offsetWidth,1),e.updateSize&&(i.style.height=`${i.clientHeight*n}px`)):e.scaleHeight&&!e.scaleWidth?(n=Math.min(t.current.parentElement.offsetHeight/t.current?.offsetHeight,1),e.updateSize&&(i.style.width=`${i.clientWidth*n}px`)):(n=Math.min(t.current.parentElement.offsetWidth/t.current?.offsetWidth,t.current.parentElement.offsetHeight/t.current?.offsetHeight,1),e.updateSize&&(i.style.width=`${i.clientWidth*n}px`,i.style.height=`${i.clientHeight*n}px`)),r(n));},[t,e.scaleWidth,e.scaleHeight,e.updateSize]),jsx(a,{width:"100%",height:"100%",children:jsx(Ap,{scale:o,ref:t,children:e.children})})}var Ap=Me(a)`
  width: fit-content;
  overflow: hidden;
  transform-origin: 0 0 0;
  transform: ${e=>`scale(${e.scale})`};
`;function _i({type:e$1="h2",title:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,collapsed:i,...a$1}){let s=n?i:false;return jsxs(Fragment,{children:[jsx(a,{mb:r?"xs":undefined,children:jsx(M,{type:e$1,...a$1,children:t})}),o&&jsx(a,{mt:"xs",mb:"xs",children:jsx(e,{fontSize:"m",children:o})}),r&&!s&&jsx(j,{children:r})]})}function Vi({title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,collapsed:a$1,onToggleCollapse:s,hasError:p,ml:d,mr:m,mb:f,mt:c}){let b=p$1("s");return jsxs(Fragment,{children:[jsxs(k,{width:"100%",justifyContent:"space-between",flexWrap:"wrap",children:[jsx(k,{flexBasis:"40%",flexGrow:1,flexShrink:1,minWidth:"100px",alignItems:r?undefined:"center",children:jsx(a,{children:jsx(_i,{ml:d,mr:m,mb:f,mt:c,title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,collapsed:a$1})})}),jsxs(k,{flexGrow:0,flexShrink:0,alignItems:b?"center":"flex-start",children:[!b&&i,s&&jsx(a,{ml:d||i?"s":undefined,mt:c||"xs",mr:m,mb:f,children:jsx(K,{"aria-expanded":a$1?"false":"true",onClick:s?()=>s(!a$1):undefined,size:"s",collapsed:a$1,disabled:p,"data-test":"sectionContent-collapseButton"})})]})]}),b&&i&&jsx(k,{width:"100%",children:i})]})}function Dt({title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,contentWhenCollapsed:a$1,maxWidth:s,hasError:p,children:d,backgroundColor:m,padding:f="lm",ml:c,mr:b,mb:u,mt:y,borderWidth:x=1,"data-test":S,...w}){return jsxs(Up,{maxWidth:s,"data-test":S,backgroundColor:m,borderWidth:x,children:[!!(e||r||o||i)&&jsx(a,{pr:f,pl:f,pt:f,children:jsx(Vi,{ml:c,mr:b,mb:u,mt:y,type:t,title:e,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,hasError:p,...w})}),w.collapsed&&(a$1?jsxs(Fragment,{children:[jsx(a,{pb:"sm"}),jsx(a,{pl:f,pr:f,children:jsx(rn,{margin:"none"})}),a$1]}):jsx(a,{pb:f})),w.collapsed?null:jsx(de,{collapsed:w.collapsed,children:d})]})}var Up=Me.section`
  background: ${e=>e.backgroundColor?e.theme.colors[e.backgroundColor]:"white"};
  border-radius: 4px;
  max-width: ${({maxWidth:e})=>e??"968px"};
  border: ${e=>`${e.borderWidth}px solid ${e.theme.colors.dividerLines}`};
`;function qp({behavior:e,localStoragePrefix:t}){let o=useMemo(()=>new Map,[]),r=useCallback(async n=>{let i=o.get(n)?.(),{collapsed:a,canCollapse:s,onToggleCollapse:p}=i??{};if(a||await s?.()){if(e==="one-section-at-one-time"){let d=Array.from(o.entries()).filter(([c])=>c!==n).map(([c,b])=>b()).filter(c=>!c.collapsed);if(!(await Promise.all(d.map(c=>c.canCollapse()))).every(c=>c))return  false;for(let c of d)c.onToggleCollapse(true);}}else return  false;return p?.(!a),true},[e,o]);return {sections:o,tryToggleSection:r,localStoragePrefix:t,behavior:e}}var [AR,Qp]=Kp(qp);function Ki(e,{canCollapse:t,onToggleCollapse:o,initiallyCollapsed:r}={}){let[n]=useState(e),{sections:i,tryToggleSection:a,localStoragePrefix:s,behavior:p}=Qp(),d=useMemo(()=>{try{let u=Array.from(i.entries()).map(([y,x])=>x()).some(y=>!y.collapsed);return r||u&&p==="one-section-at-one-time"}catch(u){if(u instanceof TypeError){let y=new SyntaxError("Section must be used within a SectionController");throw y.stack=u.stack,y}else throw u}},[i,p,r]),[m,f]=o$1(d,s?`sectionCollapsedState_${s}_${n}`:undefined),c=b$1({canCollapse:t??(async()=>true),onToggleCollapse:u=>{o?.(u),f(u);},collapsed:m});return useEffect(()=>{n!==e&&console.warn(`Section name changed! You may experience unexpected behavior. ${n} -> ${e}`);let u=c();return u.canCollapse().then(y=>{y||u.onToggleCollapse(false);}),()=>{i.delete(e);}},[e,n,i,c]),i.set(e,c),{tryToggleCollapse:useCallback(()=>a(n),[a,n]),collapsed:m}}function GR({initiallyCollapsed:e,name:t,onToggleCollapse:o,canCollapse:r,...n}){let{collapsed:i,tryToggleCollapse:a}=Ki(t,{initiallyCollapsed:e,canCollapse:r,onToggleCollapse:o});return jsx(Dt,{...n,collapsed:i,onToggleCollapse:a})}function ZR({initiallyCollapsed:e,localStorageKey:t,...o}){let[r,n]=o$1(!!e,t?`simpleSectionCollapsedState_${t}`:undefined);return jsx(Dt,{...o,collapsed:r,onToggleCollapse:()=>n(i=>!i)})}function d$({"data-test":e$1,...t}){return jsxs(a,{"data-test":e$1,children:[jsxs(a,{pb:"lm",children:[jsx(a,{pb:"s",children:jsx(M,{type:t.type,children:t.header})}),jsx(e,{color:"secondaryFont",children:t.description})]}),t.children]})}var h$=Me(l)`
  background: linear-gradient(188deg, rgba(214, 169, 232, 0.5) 6.26%, rgba(119, 210, 249, 0.2) 95.58%);
`;var C$=Me.div`
  padding-top: ${e=>e.paddingTop}px;
  width: 100%;
  height: 100%;
  background: ${e=>e.theme.colors.secondaryBackground};
`;function R$({calendar:e,children:t,hideSearch:o,hideVenueName:r,showSideNavigation:n,sideNavigationItems:i,userId:a,venueInternalDisplayName:s}){return jsxs(Fragment,{children:[n&&a&&jsx(ki,{venue:s??"",user:a??"",items:i??[],calendar:e,hideVenueName:r,hideSearch:o}),jsx(nf,{showSideNavigation:n,children:t})]})}var nf=Me.main`
  margin-left: ${e=>e.showSideNavigation?e.theme.sizes.sideNavWidth:0};
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: ${e=>e.theme.colors.secondaryBackground};
  flex-grow: 1;

  ${e=>e.showSideNavigation&&css`
      width: 100%;
      max-width: calc(100% - 194px);
    `}
`;function O$({title:e$2,subtitle:t,description:o,draggable:r,actions:n,collapsible:i,defaultCollapsed:a$1,size:s="l",memoCollapseState:p,children:d,...m}){let[f,c]=o$1(!!a$1,p?`sectionCollapsedState_${p}`:undefined);return jsxs(lf,{size:s,...m,children:[jsxs(df,{pr:"s",pl:"s",pt:o?"s":"xs",pb:o?"s":"xs",alignItems:"center",children:[r&&jsx(a,{pl:"xs",pr:"xs",children:jsx(e$1,{name:"VMSWeb-drag",color:"deactivated"})}),jsxs(cf,{pl:"s",pr:"sm",flexDirection:"column",justifyContent:"center",flex:"auto",children:[(e$2||t)&&jsxs(qi,{children:[e$2&&jsx(e,{fontWeight:"bold",children:e$2}),e$2&&t&&jsx(e,{children:" - "}),t&&jsx(e,{children:t})]}),o&&jsx(qi,{pt:"xs",children:jsx(j,{children:o})})]}),n&&jsx(A,{anchor:jsx(x,{borderType:"none-round",icon:"VMSWeb-more-vertical",size:"s","data-test":"settingsSection-menuButton"}),children:n}),i&&jsx(a,{ml:"s",children:jsx(K,{size:"s",collapsed:f,onToggle:c,"data-test":"settingsSection-collapseButton"})})]}),jsx(de,{collapsed:f,children:d})]})}var lf=Me.section`
  max-width: ${e=>e.size==="l"?"920px":"448px"};
`,df=Me(k)`
  background: ${e=>e.theme.colors.secondaryBackground};
  border-radius: 4px;
`,cf=Me(k)`
  width: 0;
  min-height: ${e=>e.theme.spacing.l};
  font-size: ${e=>e.theme.fontSizes.m};
`,qi=Me(a)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;function pf({show:e,...t},o){return jsx(ff,{...t,ref:o,display:e?"flex":"none",backgroundColor:"overlayBackground",position:"absolute",overflow:"hidden"})}var Z$=Z.forwardRef(pf),ff=Me(k)`
  transition: ${f.animation.duration.overlay} ease;
  gap: ${e=>e.theme.spacing.m};
  lex: none;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;function Ji({children:e,close:t}){return jsx(s,{children:o=>jsx(hf,{zIndex:o,pr:"lm",pl:"lm",children:e?jsx(e.type,{...e.props,close:t}):null})})}var hf=Me(a)`
  display: flex;
  align-items: center;
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0px -2px 4px rgba(9, 34, 56, 0.1);
  height: 58px;
  width: 100%;
`;function ji({title:e,onClose:t,showCloseButton:o=true}){return jsx(s,{children:r=>jsxs(bf,{pl:"lm",pr:"sm",zIndex:r,children:[jsx(M,{type:"h2",children:e}),o&&jsx(x,{"data-test":"ui-kit-slideout-close",borderType:"none-round",icon:"VMSWeb-close",onClick:t,"aria-label":"Close"})]})})}var bf=Me(a)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0 2px 4px rgba(9, 34, 56, 0.1);
  height: 58px;
  width: 100%;

  h2 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  button {
    flex-shrink: 0;
  }
`;function xB({show:e,title:t,background:o,noTopPadding:r,width:n=800,children:i,enableBackdrop:a=false,enableFocusLock:s=false,enableAutoFocus:p=true,enableReturnFocus:d=false,enableScrollLock:m=false,handleFocusableElements:f=false,footer:c=null,shouldCloseOnClick:b=false,shouldCloseOnEscapePress:u=true,showCloseButton:y=true,onBeforeClose:x=he.noop,onCloseComplete:S=he.noop,onOpenComplete:w=he.noop,"data-test":C}){return jsx(An,{show:e,enableBackdrop:a,enableFocusLock:s,enableAutoFocus:p,enableReturnFocus:d,enableScrollLock:m,shouldCloseOnClick:b,shouldCloseOnEscapePress:u,onExited:S,onEntered:w,onBeforeClose:x,handleFocusableElements:f,children:({state:k,close:$})=>jsxs(Cf,{"data-test":C,width:n,"data-state":k,children:[jsx(ji,{title:t,onClose:$,showCloseButton:y}),jsx(Sf,{noTopPadding:r,background:o,children:typeof i=="function"?i({close:$}):i}),jsx(Ji,{close:$,children:c})]})})}var Sf=Me.div`
  flex: 1;
  flex-basis: ${({width:e})=>typeof e=="string"?e:`${e}px`};
  overflow: auto;
  background: ${e=>e.theme.colors[e.background??"primaryBackground"]};
  padding: ${e=>`${e.theme.spacing.l} ${e.theme.spacing.lm}`};

  ${e=>e.noTopPadding&&css`
      padding-top: 0;
    `}
`,Cf=Me.div`
  position: absolute;
  left: auto;
  right: 0;
  height: 100vh;
  max-height: 100%;
  width: ${({width:e})=>typeof e=="string"?e:`${e}px`};
  max-width: 100vw;
  transform: translateX(100%);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(9, 34, 56, 0.1);

  ${({theme:{animation:e}})=>css`
    &[data-state='entering'],
    &[data-state='entered'] {
      animation: ${Pf} ${e.duration.slideOut} ${e.easing.deceleration} both;
    }
    &[data-state='exiting'],
    &[data-state='exited'] {
      animation: ${vf} ${e.duration.slideOut} ${e.easing.acceleration} both;
    }
  `}
`,Pf=keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`,vf=keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;function RB({title:e$1,description:t,actions:o,collapsible:r,collapsed:n,children:i,onClick:a$1,...s}){return jsxs(Rf,{highlightOnHover:n&&!!a$1,...s,children:[!!(e$1||t||o||r)&&jsx(Tt,{gridTemplateColumns:"repeat(12, 1fr)",gap:"lm",gridAutoRows:"min-content",children:jsx(Jr,{maxWidth:"100%",gridColumn:"auto / span 12","data-test":"ui-kit-slideout-subsection-clickable",onClick:a$1,children:jsx(a,{pr:"lm",pl:"lm",pt:"m",children:jsxs(k,{flexDirection:"column",children:[jsx(a,{children:jsxs(k,{justifyContent:"space-between",alignItems:"center",children:[jsx(a,{children:jsx(M,{type:"h3",children:e$1})}),jsx(k,{children:o})]})}),jsx(a,{children:jsx(e,{children:t})})]})})})}),i]})}var Rf=Me.section`
  background: white;
  border-radius: 10px;
  max-width: 752px;
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  overflow: hidden;
  ${e=>e.height&&`height: ${e.height};`}
  ${e=>e.highlightOnHover&&css`
      &:hover {
        border: 1px solid ${e.theme.colors.secondaryFont};
      }
    `}
`;var ra=Me.table`
  height: 1px;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  box-sizing: border-box;
  margin-bottom: 0;

  th,
  td {
    border: none;
    padding: 0;
  }
`;var na=Me.tbody``;function Vt(e$1){return jsx(Mf,{as:e$1.isHeader?"th":undefined,...e$1,children:jsx(q,{...e$1,children:jsx(If,{...e$1,children:jsx(e,{fontSize:"m",type:"div",width:"100%",fontWeight:e$1.isHeader?"bold":undefined,textDisplay:e$1.textDisplay,justifyContent:e$1.justifyContent,textAlign:e$1.textAlign,children:e$1.children})})})})}var If=Me.div`
  display: ${e=>e.displayBlock?"block":"flex"};
  padding: 19px ${e=>`${e.theme.spacing.m}`};
  height: 100%;
  width: 100%;
  align-items: ${e=>e.alignItems??"center"};
  box-sizing: border-box;

  justify-content: ${e=>{switch(e.justifyContent){case undefined:case "center":return e.justifyContent;default:return `flex-${e.justifyContent}`}}};

  ${e=>e.removeRightPadding&&css`
      padding-right: 0;
    `}

  ${e=>e.backgroundColor&&css`
      background-color: ${e.theme.colors[e.backgroundColor]};
    `}

  ${e=>e.removeLeftPadding&&css`
      padding-left: 0;
    `}

  ${e=>e.shouldAddNestingPadding&&css`
      padding-left: ${e.theme.spacing.l};
    `}

    ${e=>e.removePadding&&css`
      padding: 0;
    `}
`,q=Me.div`
  min-height: 54px;
  border-bottom: ${e=>e.noBorderBottom?"none":`1px solid ${e.theme.colors.borders}`};
  border-left: ${e=>e.borderLeft?`1px solid ${e.theme.colors.borders}`:"none"};
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  ${e=>e.isHeader&&css`
      white-space: nowrap;
      height: 100%;
      border-top: ${e.noTopBorder?"none":`1px solid ${e.theme.colors.borders}`};
    `};
`,Mf=Me.td`
  background: ${e=>e.isNested?e.theme.colors.secondaryBackground:"white"};
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  ${e=>e.isHeader&&css`
      text-align: ${e.headerAlign||"left"};
    `};

  ${e=>e.attach==="left"&&css`
      position: sticky;
      left: 0;
      z-index: ${e.isHeader?1:0};

      & > ${q} {
        box-shadow: ${e.noBoxShadow?"none":`2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `};

  ${e=>e.isHeader&&css`
      position: sticky;
      top: 0;
      z-index: ${e.attach===undefined?0:1};

      ${q} {
        box-shadow: ${e.noBoxShadow?"none":`2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `}

  ${e=>e.attach==="right"&&css`
      position: sticky;
      right: 0;
      z-index: ${e.isHeader?1:0};

      & > ${q} {
        box-shadow: ${e.noBoxShadow?"none":`-2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `};

  &:first-child > ${q} {
    border-left: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  }

  &:last-child > ${q} {
    border-right: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  }

  ${e=>e.isInFirstRow&&css`
      &:first-child > ${q} {
        border-top-left-radius: ${t=>t.theme.table.borderRadius};
      }

      &:last-child > ${q} {
        border-top-right-radius: ${t=>t.theme.table.borderRadius};
      }
    `};

  ${e=>e.isInLastRow&&css`
      &:first-child > ${q} {
        border-bottom-left-radius: ${t=>t.theme.table.borderRadius};
      }

      &:last-child > ${q} {
        border-bottom-right-radius: ${t=>t.theme.table.borderRadius};
      }
    `};

  ${({width:e})=>e&&css`
      width: ${typeof e=="string"?e:`${e}px`};
    `}

  ${({minWidth:e})=>e&&css`
      min-width: ${typeof e=="string"?e:`${e}px`};
    `}

  ${({maxWidth:e})=>e&&css`
      max-width: ${typeof e=="string"?e:`${e}px`};
    `}
`;var GB=Me.tfoot``;var KB=Me.thead``;var aa=Me.tr`
  ${e=>e.hoverOnRows&&css`
      &:hover td {
        cursor: pointer;
        background: ${t=>t.theme.colors.secondaryBackground};
      }
    `}

  ${e=>e.isSelected&&css`
      && {
        td {
          background: ${t=>t.theme.colors.margin};
        }
      }
    `}
`;function la(e){let{formatMessage:t}=useLocales();return jsx(Fragment,{children:e.row.canExpand?jsxs(k,{alignItems:"center",onClick:o=>{o.stopPropagation();},children:[e.value,jsx(a,{p:"s",children:jsx(x,{"data-test":"ui-kit-spreadsheet-expand-cell",...e.row.getToggleRowExpandedProps({}),title:t(e.row.isExpanded?commonMessages.collapse:commonMessages.expand),borderType:"none-round",icon:e.row.isExpanded?"VMSWeb-chevron-down":"VMSWeb-chevron-right"})})]}):e.value})}function da(e){let t=Z__default.useCallback(o=>{switch(o){case "first":return e.table.gotoPage(0);case "prev":return e.table.previousPage();case "next":return e.table.nextPage();case "last":return e.table.gotoPage(e.table.pageCount-1);default:return e.table.gotoPage(o)}},[e.table]);return jsx(k,{justifyContent:"flex-end",children:jsxs(zf,{children:[jsx(Af,{noBorder:e.noBorder}),jsx(Of,{noBorder:e.noBorder,children:jsx(Ri,{currentPage:e.table.state.pageIndex+1,totalItemsCount:e.totalItemsCount,rowsPerPage:e.table.state.pageSize,canPreviousPage:e.table.canPreviousPage,canNextPage:e.table.canNextPage,onPerPageChange:e.table.setPageSize,goToPage:t})})]})})}var zf=Me.div`
  background: ${e=>e.theme.colors.primaryBackground};
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  border-top: 1px solid ${e=>e.theme.colors.borders};
`,Af=Me.div`
  position: sticky;
  width: 100%;
  left: 0;
  margin-right: auto;
  border-bottom: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-left: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-bottom-left-radius: ${e=>e.theme.table.borderRadius};
`,Of=Me.div`
  position: sticky;
  min-width: max-content;
  right: 0;
  padding: ${e=>`${e.theme.spacing.m} ${e.theme.spacing.lm}`};
  border-bottom: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-right: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-bottom-right-radius: ${e=>e.theme.table.borderRadius};
`;function ma({pin:e,...t}){let o=useRef(null);useEffect(()=>{let n=he.debounce(()=>{let i=document.querySelector("html");if(o.current&&i&&e){let a=e?e.getBoundingClientRect().bottom:0;if(i.scrollTop>=o.current.offsetTop-a){let s=i.scrollTop-o.current.offsetTop+a;o.current.setAttribute("style",`transition:0s; transform: translate3d(0px, ${s}px, 0px);`);}else o.current.setAttribute("style","transition:0s; transform: translate3d(0px, 0px, 0px);");}},200);return e&&window.addEventListener("scroll",n),()=>{window.removeEventListener("scroll",n);}},[e]);function r(n,i){let a=n;return typeof a.spreadsheetColumn.header=="string"&&a.spreadsheetColumn.header.length?{"data-test":`ui-kit-spreadsheet-${i}-${a.spreadsheetColumn.header}`}:{}}return jsx(Kf,{ref:o,children:t.headerGroups.map(n=>jsx("tr",{...n.getHeaderGroupProps(),children:n.headers.map(i=>jsxs(Vt,{...i.getHeaderProps(i.getSortByToggleProps()),isHeader:true,isInFirstRow:!t.hideTopCorners,noBoxShadow:t.noBoxShadow,textDisplay:i.spreadsheetColumn.textDisplay,justifyContent:i.spreadsheetColumn.headerAlign??"center",attach:i.spreadsheetColumn.attach,width:i.spreadsheetColumn.width,minWidth:i.spreadsheetColumn.minWidth,maxWidth:i.spreadsheetColumn.maxWidth,backgroundColor:i.spreadsheetColumn.backgroundColor,removePadding:i.spreadsheetColumn.removePadding,noTopBorder:t.noBorder,noBorder:t.noBorder,...r(i,"header"),children:[i.render("Header"),i.isSorted?jsxs("span",{...r(i,"header-sort-arrow"),children:[jsx("span",{children:" "}),jsx(e$1,{name:i.isSortedDesc?"VMSWeb-arrow-down":"VMSWeb-arrow-up"})]}):""]}))}))})}var Kf=Me.thead`
  position: relative;
  z-index: 1;
`;var L1=forwardRef(rg);function rg(e,t){let o=typeof e.data=="function",r=u(),[n,i]=useState(false),a=useRef(null),s=useRef(null);useImperativeHandle(t,()=>({deselectAll:()=>{u$1.toggleAllRowsSelected(false);}}));let p=useCallback(x=>typeof x=="function"?{data:[],pagination:{pageCount:-1,totalItemsCount:-1}}:{data:x,pagination:{pageCount:-1,totalItemsCount:x.length}},[]),d=useMemo(()=>p(e.data),[p,e.data]),[m,f]=Z__default.useState(()=>d),c=useMemo(()=>o?m:d,[d,o,m]),b=Z__default.useMemo(()=>e.columns.map(x=>{let S={Header:x.header,accessor:x.render,id:"key"in x?x.key:undefined,spreadsheetColumn:x,disableSortBy:!x.sortable,...x.sortType&&{sortType:x.sortType}};return x.expandable&&(S.id="expander",S.Cell=la),S}),[e.columns]),u$1=useTable({data:c.data,columns:b,manualPagination:o,manualSortBy:o,pageCount:c.pagination.pageCount,disableSortBy:e.disableSortBy,initialState:{...e.sorted&&{sortBy:e.sorted},...e.initialPageSize&&{pageSize:e.initialPageSize}},autoResetExpanded:e.autoResetExpanded||false},useSortBy,useExpanded,usePagination,useRowSelect),y=e.noPagination?u$1.rows:u$1.page;return Z__default.useEffect(()=>{e.onChange?.(u$1.state),typeof e.data=="function"&&e.data(u$1.state).then(x=>{f(x);});},[u$1.state.pageIndex,u$1.state.pageSize,u$1.state.sortBy,e.onChange]),Z__default.useEffect(()=>{let x=s.current;x&&i(x.clientWidth<x.scrollWidth);},[r]),Z__default.useEffect(()=>{e.onSortedChange?.(u$1.state.sortBy);},[e.onSortedChange,u$1.state.sortBy]),jsxs(ig,{width:e.width,height:e.height,maxHeight:e.maxHeight,ref:a,children:[e.filterPanel,jsxs(ag,{isVerticalScrollBlocked:e.isVerticalScrollBlocked,children:[jsx(sg,{...u$1.getTableProps(),ref:s,children:jsxs(ra,{children:[jsx(ma,{headerGroups:u$1.headerGroups,noBoxShadow:!n,hideTopCorners:!!e.filterPanel||e.noBorder,noBorder:e.noBorder,pin:e.pin}),!e.placeholder&&jsx(na,{...u$1.getTableBodyProps(),children:y.map((x,S,w)=>{u$1.prepareRow(x);let C=S===w.length-1,k=e.renderPreComponent&&e.renderPreComponent({row:x,index:S,rows:y,containerWidth:`${a?.current?.clientWidth}px`}),$=e.renderPostComponent&&e.renderPostComponent({row:x,index:S,rows:y,containerWidth:`${a?.current?.clientWidth}px`});return jsxs(Z__default.Fragment,{children:[k&&jsx("tr",{children:jsx("td",{width:"100%",colSpan:100,children:k})}),jsx(aa,{...x.getRowProps(),isSelected:x.isSelected,hoverOnRows:e.hoverOnRows,onClick:()=>{e.onRowClick&&(u$1.toggleAllRowsSelected(false),u$1.toggleRowSelected(x.id,true),e.onRowClick(x.original));},children:x.cells.map((L,ne)=>{let R=L.column.spreadsheetColumn;return jsx(Vt,{...L.getCellProps(),isNested:x.depth>0,isInLastRow:e.noPagination&&C,removeRightPadding:x.canExpand,shouldAddNestingPadding:x.depth>0&&ne===0,noBorderBottom:!e.noPagination&&C,noBoxShadow:!n,attach:R.attach,width:R.width,minWidth:R.minWidth,maxWidth:R.maxWidth,justifyContent:R.cellAlign??"start",textAlign:R.cellAlign??"start",noBorder:e.noBorder,alignItems:R.alignItems,backgroundColor:R.backgroundColor,removePadding:R.removePadding,children:L.render("Cell")})})}),$&&jsx("tr",{children:jsx("td",{width:"100%",colSpan:100,children:$})})]},x.id)})}),!e.noPagination&&jsx("tfoot",{children:jsx("tr",{children:jsx(lg,{colSpan:b.length,children:jsx(da,{table:u$1,totalItemsCount:c.pagination.totalItemsCount,noBorder:e.noBorder})})})})]})}),jsx(ng,{children:e.placeholder})]})]})}var ng=Me.div`
  position: sticky;
  left: 0;
  width: 100%;
`,ig=Me.div`
  ${e=>e.width&&css`
      width: ${typeof e.width=="string"?e.width:`${e.width}px`};
    `}

  ${e=>e.height&&css`
      height: ${typeof e.height=="string"?e.height:`${e.height}px`};
    `}

  ${e=>e.maxHeight&&css`
      max-height: ${typeof e.maxHeight=="string"?e.maxHeight:`${e.maxHeight}px`};
    `}
`,ag=Me.div`
  width: 100%;
  height: 100%;
  max-height: inherit;
  overflow-y: ${e=>e.isVerticalScrollBlocked?"hidden":"auto"};
`,sg=Me.div`
  width: 100%;
  height: 100%;
  display: flex;
`,lg=Me.td`
  position: sticky;
  bottom: 0;
  padding: 0;
`;function H1({primary:e$1,secondary:t,...o}){return jsxs(cg,{...o,twoLineEllipsis:t===undefined,children:[jsx(e,{children:e$1}),jsx("br",{}),jsx(e,{color:"secondaryFont",children:t})]})}var ga=(e,t)=>e==="number"||typeof t=="number"?(e||0)>(t||0)?1:-1:(e||"").toLowerCase()>(t||"").toLowerCase()?1:-1,D1=(e,t,o)=>{let r=e.values[o]?.props,n=t.values[o]?.props,i=r.primary,a=n.primary;return i!==a?ga(i,a):ga(r.secondary,n.secondary)},cg=Me.div`
  box-sizing: content-box;
  min-height: 36px;

  ${e=>e.twoLineEllipsis?h:f$1}
`;function U1({title:e$1,description:t,image:o,alt:r,pt:n="xl",pb:i="xl"}){return jsxs(fg,{width:"100%",pt:n,pb:i,alignItems:"center",children:[o&&jsx(a,{mb:"l",children:jsx("img",{src:o,alt:r})}),e$1&&jsx(a,{children:jsx(e,{fontWeight:"bold",fontSize:"l",children:e$1})}),t&&jsx(a,{mt:"s",children:jsx(e,{color:"secondaryFont",children:t})})]})}var fg=Me(n$1)`
  background: ${e=>e.theme.colors.primaryBackground};
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;function q1({children:e,...t}){return jsx(hg,{width:"100%",p:"m",spacing:"m",flexWrap:"wrap",...t,children:e})}var hg=Me(P)`
  background: ${e=>e.theme.colors.primaryBackground};
  border: 1px solid ${e=>e.theme.colors.borders};
  border-bottom: 0;
  border-top-left-radius: ${e=>e.theme.table.borderRadius};
  border-top-right-radius: ${e=>e.theme.table.borderRadius};
`;function oI({children:e$1,width:t}){return jsx(bg,{children:jsx(yg,{width:t,pt:"s",pb:"s",pl:"m",pr:"m",children:jsx(e,{textTransform:"uppercase",color:"secondaryFont",fontSize:"s",children:e$1})})})}var bg=Me.div`
  background-color: ${e=>e.theme.colors.dividerLines};
  width: 100%;
`,yg=Me(a)`
  background-color: ${e=>e.theme.colors.dividerLines};
  box-sizing: border-box;
  max-width: ${e=>e.width};
  min-width: ${e=>e.width};
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  border-top: none;
  position: sticky;
  left: 0;
`;function hI(e){return jsx(Cg,{...e,selectedTabClassName:"selected",selectedTabPanelClassName:"selected"})}var Cg=Me(fe.Tabs)`
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  line-height: ${e=>e.theme.lineHeights.s};
`,Pe=Me(fe.Tab)`
  position: relative;
  padding: 11px 0;
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  line-height: ${e=>e.theme.lineHeights.s};
  user-select: none;
  cursor: default;
  list-style: none;

  &.selected {
    font-weight: 700;
    &::after {
      content: ' ';
    }
  }

  &:focus {
    outline: none;
  }

  &::before {
    content: ' ';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  &::after {
    display: block;
    position: absolute;
    height: 2px;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(2px);
    background: ${e=>e.theme.colors.primaryFont};
  }

  &::marker {
    display: none;
  }
`;Pe.tabsRole="Tab";var Pg=Me(fe.TabList)`
  width: max-content;
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  border-bottom: 2px solid ${e=>e.theme.colors.borders};

  ${e=>css`
    ${Pe} + ${Pe} {
      margin-left: ${e.theme.spacing.l};
    }

    ${Pe}:first-child {
      &::before {
        margin-right: -${e.theme.spacing.m};
      }
    }

    ${Pe}:last-child {
      &::before {
        margin-left: -${e.theme.spacing.m};
      }
    }

    ${Pe} + ${Pe}:not(:last-child) {
      &::before {
        margin: 0 -${e.theme.spacing.m};
      }
    }
  `}
`;Pg.tabsRole="TabList";var vg=Me(fe.TabPanel)`
  display: none;

  &.selected {
    display: block;
  }
`;vg.tabsRole="TabPanel";function ha({options:e,value:t,onChange:o,disabled:r,backgroundColor:n="primaryBackground",...i}){let a=g(n,"lightFont","darkFont")==="lightFont",s=p$1("s"),p=p$1("xs"),d=useMemo(()=>{if(!s)return;let f=e.find(c=>c.id===t);if(f)return $g(f.id)},[s,e,t]),m="desktop";return p?m="tiny":s&&(m="mobile"),jsx(Bg,{backgroundColor:n,disabled:r,isLightTheme:a,languagePickerWidth:m,children:jsx(Fe,{options:e,onChange:o,value:t,displayValue:d,searchable:false,hideFilterIcon:p,disabled:r,withNativeSupport:true,filterIcon:jsx(e$1,{name:"GX-language","data-test":"language-picker-icon"}),"data-test":"language-picker",...i})})}var $g=e=>{switch(e){case "zh_CN":return "\u7B80\u4F53";case "zh_HK":return "\u7E41\u9AD4";case "ja":return "\u65E5\u672C\u8A9E";case "th":return "\u0E44\u0E17\u0E22";default:return e.toUpperCase()}},Bg=Me(a)`
  width: ${e=>e.theme.topNav.languagePickerWidth[e.languagePickerWidth]};
  ${ea} {
    --border-color: ${e=>e.theme.colors.secondaryFont};
    background: ${e=>e.theme.colors[e.backgroundColor]};
  }
  ${e=>e.isLightTheme&&css`
      ${ea} {
        border-color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }

      ${$} {
        color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }

      ${f$2} {
        color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }
    `}

  @media (max-width: ${e=>e.theme.breakpoints.s}px) {
    ${Co} {
      padding: ${e=>`${e.theme.spacing.sm} ${e.theme.spacing.s} ${e.theme.spacing.sm} ${e.theme.spacing.s}`};
    }
    ${$}, ${aa$1} {
      padding: 11px 0 11px 44px;
    }
    ${ca} {
      > i {
        margin: 0 14px;
      }
    }
  }

  @media (max-width: ${e=>e.theme.breakpoints.xs}px) {
    ${$}, ${aa$1} {
      padding: 11px 0 11px 16px;
    }
  }
`;var Ng=e=>/.+?-app\.qa\.sevenrooms\.com/g.test(e)?"https://staging-app.qa.sevenrooms.com":e.includes("eu.")?"https://www.sevenrooms.com":`https://${e}`,xa=Ng(window.location.host),Hg=`${xa}/app/global-client`;function ba({onLogin:e,onUpdate:t,onDelete:o,onCreate:r,onClose:n,onLoad:i,isProfilePage:a=false}){let s=useRef(null),p=useCallback(d=>{let m=readIFrameMessage(d,xa);if(m)switch(m.topic){case "create":r(or(m.data.userInfo));break;case "error":break;case "login":e(or(m.data.userInfo));break;case "update":t(or(m.data.userInfo));break;case "delete":o();break;case "resize":if(!s.current)break;s.current.width=m.data.width,s.current.height=m.data.height;break;case "close":n();break;case "open":i();break;}},[e,t,o,r,n,i]);return useEffect(()=>(window.addEventListener("message",p),()=>{window.removeEventListener("message",p);}),[p]),jsx(Ag,{title:"sevenrooms-login",src:`${Hg}${a?"/profile":""}`,height:"245px",ref:s})}var or=({id:e,emailAddress:t,firstName:o,lastName:r,phoneNumber:n,profilePictureUrl:i,significantDates:a,preferences:s})=>{let{phoneCountryCode:p,phoneDialCode:d}=Dg(n);return {clientId:e,firstName:o,lastName:r,emailAddress:t,phoneNumber:n,phoneDialCode:d,phoneCountryCode:p,profilePictureUrl:i,significantDates:a,preferences:s}},Dg=e=>{let t=parsePhoneNumber(e,{extract:true});return {phoneCountryCode:zg(t?.country),phoneDialCode:t?.countryCallingCode}},zg=e=>e?.toLowerCase(),Ag=Me.iframe`
  max-width: 100%;
  max-height: 100%;
  border: 0;
  @media (min-width: 535px) {
    width: 530px;
  }
  @media (max-width: 530px) {
    width: 100%;
  }
`;function Sa({active:e,setIsActive:t,closeable:o,children:r}){let n=useNavigation(),i=useSurfaceScope(),a=zi(),s=Z.useMemo(()=>Math.random().toString(),[]),p=Z.useCallback(()=>{o&&i?.destination.parent&&n.push(i.destination.parent,{from:i.destination}),t?.(false);},[n,o,t,i?.destination]),[d,m]=Z.useState(null),f=Z.useMemo(()=>({key:s,setNode:m,close:p}),[p,s]),c=e??n.matchParams(i?.destination)!==undefined;return Z.useLayoutEffect(()=>(c&&a.register(f),()=>{a.unregister(f);}),[c]),d&&Hi.createPortal(r,d)}function Ta({firstName:e$1,lastName:t,image:o,onLogout:r,onProfileClick:n,dataTest:i}){let{formatMessage:a}=useLocales(),[s,p]=Z__default.useState(null),d=!!s,m=c=>{p(c.currentTarget);},f=()=>{p(null);};return jsxs(Fragment,{children:[jsx(IconButton,{"data-test":i,sx:{padding:"3px"},size:"small",onClick:m,"aria-controls":d?"user-profile":undefined,"aria-haspopup":"true","aria-expanded":d?"true":undefined,children:jsx(Avatar,{sx:{width:36,height:36},src:o,children:`${e$1[0]}${t[0]}`.toUpperCase()})}),jsxs(Menu,{transformOrigin:{horizontal:"right",vertical:"top"},anchorOrigin:{horizontal:"right",vertical:"bottom"},anchorEl:s,id:"user-profile",open:d,onClose:f,onClick:f,children:[jsx(MenuItem,{onClick:n,children:jsx(e,{children:a(gflMessages.resWidgetProfileLink)})},"profile"),jsx(MenuItem,{onClick:r,children:jsx(e,{children:a(gflMessages.resWidgetLogoutLink)})},"logout")]})]})}function ka({backgroundColor:e="venueColor",onLogin:t,onUpdate:o,onLogout:r,onDelete:n,...i}){let[a,s]=useState(false),[p,d]=useState(false),m=useCallback(x=>{s(false),t?.(x);},[t]),f=useCallback(x=>{s(false),o?.(x);},[o]),c=useCallback(()=>{s(false);},[]),b=useCallback(()=>{d(true);},[]),u=g(e,"lightFont","secondaryFont"),y=`rgba(${u==="lightFont"?"255, 255, 255":"0, 0, 0"}, 0.4)`;return jsxs(Fragment,{children:[jsx(k,{alignSelf:"center",height:"100%",justifyContent:"flex-end",width:i.fullWidth?"100%":"auto",children:jsx(tu,{onLogout:r,onUpdate:o,backgroundColor:e,fontAndBorderColor:u,outlineColor:y,setIsModalOpen:s,...i})}),jsx(Sa,{active:a,setIsActive:s,children:jsxs(Rt,{ariaLabel:"login-modal",width:"fit-content",maxWidth:"100%",children:[!p&&jsx($t,{onClose:c}),jsx(Ln,{overflow:"visible",width:"100%",pr:"none",pl:"none",pt:"sm",pb:"lm",children:jsx(ba,{onLogin:m,onUpdate:f,onDelete:n,onCreate:m,onClose:c,onLoad:b,isProfilePage:!!i.userFirstName&&!!i.userLastName})})]})})]})}function tu({isLoading:e,userFirstName:t,userLastName:o,userImage:r,onLogout:n,setIsModalOpen:i,backgroundColor:a,fontAndBorderColor:s,outlineColor:p,disabled:d,fullWidth:m,size:f}){let{formatMessage:c}=useLocales(),b=useCallback(()=>{i(true);},[i]);return e?jsx(SevenRoomsProgress,{"aria-label":"In Progress"}):t&&o?jsx(Ta,{firstName:t,lastName:o,image:r,onLogout:n,onProfileClick:b,dataTest:"sr_avatar"}):jsxs(ru,{"data-test":"sr-login-button",backgroundColor:a,fontAndBorderColor:s,outlineColor:p,borderRadius:"s",onClick:b,disabled:d,fullWidth:m,size:f,children:[jsx(SevenRoomsIcon,{sx:{marginRight:"8px"}}),c(gflMessages.resWidgetLogInButton)]})}var ou="100px",ru=Me(G)`
  width: ${e=>e.fullWidth?"100%":ou};
  background-color: ${e=>e.theme.colors[e.backgroundColor]};
  color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
  border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
  border-radius: ${e=>e.theme.borderRadius.s};

  &:focus:not(:focus-visible) {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
  }

  &:focus,
  &:hover {
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
  }

  &:focus {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    outline-offset: ${e=>e.theme.borderWidth.m};
  }

  &:focus-visible {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    outline-offset: ${e=>e.theme.borderWidth.m};
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
  }

  &:hover {
    font: ${e=>e.theme.textStyles.body1Bold};
    ${e=>`border: ${e.theme.borderWidth.l} solid ${e.theme.colors[e.fontAndBorderColor]};`}
  }
`;function TM({baseUrl:e,logo:t,logoLabel:o,languagePicker:r,grow:n=false,sevenRoomsLogin:i}){let a$1=p$1("m"),s=p$1("s"),p=p$1("xs"),{topNav:d,colors:{venueColor:m,primaryBackground:f}}=useTheme(),c=a$1?"m":"lm",b="desktop";return p?b="tiny":s&&(b="mobile"),jsxs(n$1,{"data-test":"top-nav",width:"100%",backgroundColor:"venueColor",borderBottomColor:m.toLocaleLowerCase()===f.toLocaleLowerCase()?"borders":"venueColor",justifyContent:r?"space-between":"center",zIndex:"default",position:"sticky",top:"none",children:[jsxs(P,{p:`sm ${c}`,height:a$1?d.height.mobile:d.height.desktop,justifyContent:"space-between",alignItems:"flex-start",children:[jsx(a,{width:"33%",minWidth:d.languagePickerWidth[b],children:r&&jsx(ha,{...r,backgroundColor:"venueColor"})}),jsx(au,{baseUrl:e,logoLabel:o,logo:t}),jsx(a,{width:"33%",children:i&&jsx(ka,{...i})})]}),n&&jsx(a,{width:"100%",height:`${d.spacerHeight}px`})]})}function au({logo:e$1,baseUrl:t,logoLabel:o}){let r=g("venueColor","lightFont","darkFont");return e$1?jsx(Rn,{"data-test":"logo-image",baseUrl:t,logo:e$1,logoLabel:o,height:"100%"}):jsx(n$1,{alignItems:"center",justifyContent:"center",height:"100%",children:jsx(e,{textStyle:"h1",fontSize:"xxl",color:r,children:o.toUpperCase()})})}

export { Ln as $, xB as $a, dn as A, ri as Aa, ba as Ab, ao as B, ai as Ba, Sa as Bb, Ys as C, ki as Ca, ka as Cb, zx as D, Ri as Da, TM as Db, Qx as E, Fk as Ea, sb as F, Yk as Fa, nl as G, e0 as Ga, Tt as H, s0 as Ha, il as I, g0 as Ia, un as J, T0 as Ja, Wb as K, Di as Ka, Nb as L, Pp as La, ul as M, zi as Ma, zb as N, j0 as Na, _b as O, sR as Oa, Ub as P, _i as Pa, ly as Q, Dt as Qa, vl as R, AR as Ra, Tl as S, Ki as Sa, wl as T, GR as Ta, Tn as U, ZR as Ua, Sy as V, d$ as Va, kn as W, h$ as Wa, Rn as X, C$ as Xa, Rt as Y, R$ as Ya, In as Z, O$ as Za, Kl as _, Z$ as _a, bw as a, Wn as aa, RB as ab, Ee as b, ed as ba, ra as bb, xP as c, Fn as ca, na as cb, ec as d, $t as da, Vt as db, Un as e, Nn as ea, GB as eb, P as f, Je as fa, KB as fb, Ci as g, zS as ga, aa as gb, Pm as h, nC as ha, da as hb, zr as i, Hn as ia, zf as ib, Vr as j, yC as ja, Af as jb, Ru as k, BC as ka, Of as kb, Xr as l, An as la, L1 as lb, Kr as m, qC as ma, rg as mb, Zr as n, Vn as na, lg as nb, ah as o, Qd as oa, H1 as ob, bh as p, It as pa, D1 as pb, Ih as q, lc as qa, cg as qb, Qr as r, Co as ra, U1 as rb, xs as s, Fe as sa, q1 as sb, Jr as t, _P as ta, oI as tb, Cs as u, UP as ua, hI as ub, de as v, Sv as va, Pe as vb, rn as w, Tc as wa, Pg as wb, lx as x, Bc as xa, vg as xb, Ze as y, Fv as ya, ha as yb, ln as z, ei as za, Ng as zb };
